<template>
  <div>
    <vx-card class="relative">
      <div>
        <vs-row vs-w="12" class="mb-5">
          <vs-col vs-lg="3" vs-sm="3" vs-xs="12"> </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="6"
            vs-sm="6"
            vs-xs="12"
          >
            <h3>Request Account - {{ campaignDescription.campaign_name }}</h3>
          </vs-col>

          <vs-col vs-lg="3" vs-sm="3" vs-xs="12">
         
          </vs-col>

          <vs-col vs-lg="3" vs-sm="3" vs-xs="12"> </vs-col>
        </vs-row>
      </div>
    </vx-card>

    <vs-popup
      title="Move an existing contact in this campaign from another account to this account"
      :active.sync="MoveExistingContactToThisAccountPopUpActive"
      fullscreen
      :button-close-hidden="true"
      @close="closeMoveExistingContactToThisAccountPopUpActive"
    >
      <vs-row vs-w="12" class="mb-5">
        <vs-col vs-lg="8" vs-sm="8" vs-xs="12">
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Search Account:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <AccountAutocomplete
                :key="MoveExistingContactToThisAccountKey"
                class="searchbox"
                :list="searchAccountFromTheCampaign"
                :searchOn="'company_or_registration_no'"
                @event-name="selectAccountToAddContactToThisAccount"
              ></AccountAutocomplete>
            </div>
          </div>
          <div class="vx-row mb-3" v-if="acc_id != null">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Master DB Contacts:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <div
                :class="
                  existing_master_database_contacts.length > 0
                    ? scrollClass
                    : ''
                "
              >
                <template
                  v-for="(match, index) in existing_master_database_contacts"
                >
                  <p class="p-3">
                    <vs-radio
                      v-model="selected_existing_master_database_contacts"
                      :vs-value="match"
                      class="mr-4"
                      vs-name="theme-mode-dark"
                    >
                      {{ match.title }} {{ match.forename }}
                      {{ match.surname }} - {{ match.job_title }}
                    </vs-radio>
                  </p>
                </template>

                <div
                  class="vx-row mb-6"
                >
                  <div class="vx-col w-full ml-6 mt-5">
                    <vs-button
                      :disabled="
                        selected_existing_master_database_contacts == null
                      "
                      @click.prevent="submitExistingMasterDatabaseContacts"
                      >Move this Contact</vs-button
                    >
                    <vs-button
                      class="ml-3"
                      @click.prevent="closeMoveExistingContact()"
                      >Cancel</vs-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </vs-col>

        <vs-col
          vs-lg="4"
          vs-sm="4"
          vs-xs="12"
          v-if="showUpdateSContactDetailsPopup"
        >
          <u> <h4 class="font-bold text-lg mb-5">Contact Details</h4></u>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/4 w-full">
              <h5>Title:</h5>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              {{ updateContactDescription.title }}
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/4 w-full">
              <h5>Forename:</h5>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              {{ updateContactDescription.forename }}
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/4 w-full">
              <h5>Surname:</h5>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              {{ updateContactDescription.surname }}
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/4 w-full">
              <h5>Job Title:</h5>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              {{ updateContactDescription.job_title }}
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/4 w-full">
              <h5>Seniority:</h5>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              {{
                updateContactDescription.seniority != undefined &&
                updateContactDescription.seniority.length > 0
                  ? updateContactDescription.seniority[0].seniority
                  : ''
              }}
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/4 w-full">
              <h5>Role:</h5>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              {{
                updateContactDescription.role != undefined &&
                updateContactDescription.role.length > 0
                  ? updateContactDescription.role[0].role
                  : ''
              }}
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/4 w-full">
              <h5>Sub Role:</h5>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              {{
                updateContactDescription.sub_role != undefined &&
                updateContactDescription.sub_role.length > 0
                  ? updateContactDescription.sub_role[0].sub_role
                  : ''
              }}
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <h5>Email</h5>
            </div>
          </div>

          <template v-for="(email, index) in updateContactDescription.emails">
            <div class="vx-row p-2">
              <div class="vx-col sm:w-1/4 w-full">
                {{ email.email }}
              </div>
            </div>
          </template>

          <vs-divider class="m-5" />

          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <h5>Social Media Pages</h5>
            </div>
          </div>

          <template
            v-for="(
              social_media, index
            ) in updateContactDescription.social_medias"
          >
            <div class="vx-row">
              <div class="vx-col w-full">
                {{ social_media.social_media }}
                {{ ' - ' + social_media.summary }}
              </div>
            </div>
          </template>

          <vs-divider class="m-5" />

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <h5>DDI</h5>
            </div>
          </div>

          <template v-for="(ddi, index) in updateContactDescription.ddis">
            <div class="vx-row p-2">
              <div class="vx-col w-full">
                {{ ddi.ddi == null ? '' : ddi.ddi_phone_code + ' - '
                }}{{ ddi.ddi }}
              </div>
            </div>
          </template>

          <vs-divider class="m-5" />

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <h5>Mobile</h5>
            </div>
            <div class="vx-col w-full"></div>
          </div>

          <template v-for="(mobile, index) in updateContactDescription.mobiles">
            <div class="vx-row p-2">
              <div class="vx-col w-full">
                {{
                  mobile.mobile == null ? '' : mobile.mobile_phone_code + ' - '
                }}{{ mobile.mobile }}
              </div>
            </div>
          </template>
          <vs-divider class="m-10" />
        </vs-col>
      </vs-row>
    </vs-popup>

    <div>
      <vs-popup
        title="Please choose one of the options below to proceed"
        :active.sync="ChooseOptionPopupActive"
        :button-close-hidden="true"
        @close="closeChooseOptionPopup"
      >
        <div>
          <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="12"
              vs-sm="12"
              vs-xs="12"
            >
              <vs-button
                class="m-3"
                color="danger"
                @click="CreateNewContactForThisAccount"
                type="filled"
                >I want to create a new contact</vs-button
              >
            </vs-col>

            <vs-col
              vs-lg="12"
              vs-sm="12"
              vs-xs="12"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
            >
              <vs-button
                class="m-3"
                color="danger"
                @click="DontAddContactToThisAccount"
                type="filled"
                >I do not want to add a contact to this account now</vs-button
              >
            </vs-col>

            <vs-col
              vs-lg="12"
              vs-sm="12"
              vs-xs="12"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
            >
              <vs-button
                class="m-3"
                color="danger"
                @click="MoveExistingContactToThisAccount"
                type="filled"
                >I want to move an existing contact in this campaign from
                another account to this account</vs-button
              >
            </vs-col>
          </vs-row>
        </div>
      </vs-popup>
    </div>

    <vs-popup
      title="List of Accounts Matched By Website"
      :active.sync="MatchedWebsitePopupActive"
      :fullscreen="showUpdateSAccountDetailsPopup"
       :button-close-hidden="true"
        @close="closeMatchedWebsitePopup"



    >
      <vs-row vs-w="12" class="mb-5">
        <vs-col
          :vs-lg="showUpdateSAccountDetailsPopup ? 6 : 12"
          :vs-sm="showUpdateSAccountDetailsPopup ? 6 : 12"
          vs-xs="12"
        >
          <div class="text-center">
            <template v-for="(match, index) in matched_websites">
              <p class="p-2">{{ match.company_name }}</p>
              <p class="p-2">{{ match.registered_office_country }}</p>
              <p class="p-2">
                {{ match.company_registration_number
                }}<vs-icon
                  @click.stop="viewAccountDetails(match.id)"
                  size="small"
                  icon="info"
                  style="cursor: pointer; margin-left: 15px"
                ></vs-icon>
              </p>
            </template>
          </div>

          <div class="vx-row mt-5">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button @click="AddWebsiteAnyWay()" class="mr-3 mb-2"
                >Add Anyway</vs-button
              >

              <vs-button @click="CancelWebsitePopup()" class="mr-3 mb-2"
                >Cancel</vs-button
              >
            </div>
          </div>
        </vs-col>

        <vs-col
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
          v-if="showUpdateSAccountDetailsPopup"
        >
          <u> <h4 class="font-bold text-lg mb-5">Account Details</h4></u>

          <div class="p-5">
            <div class="vx-row mb-6" v-if="viewAccountDescription.company_name">
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> Company Name: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.company_name }}
              </div>
            </div>
            <div
              class="vx-row mb-6"
              v-if="viewAccountDescription.actual_account_name"
            >
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> Actual Account Name: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.actual_account_name }}
              </div>
            </div>
            <div
              class="vx-row mb-6"
              v-if="viewAccountDescription.company_registration_number"
            >
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> Registration Number: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.company_registration_number }}
              </div>
            </div>

            <div class="vx-row mb-6" v-if="viewAccountDescription.status">
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> Company Status: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.status }}
              </div>
            </div>
            <div
              class="vx-row mb-6"
              v-if="viewAccountDescription.company_category"
            >
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> Company Category: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.company_category }}
              </div>
            </div>
            <div
              v-if="
                viewAccountDescription.registered_office_address_1 ||
                viewAccountDescription.registered_office_address_2 ||
                viewAccountDescription.registered_office_address_3 ||
                viewAccountDescription.registered_office_city ||
                viewAccountDescription.registered_office_county ||
                viewAccountDescription.registered_office_country ||
                viewAccountDescription.registered_office_country
              "
            >
              <vs-divider class="m-5" />
              <!-- Registered Office -->
              <h5 class="mb-5 font-bold">Registered Office Address</h5>
            </div>
            <div
              class="vx-row mb-6"
              v-if="viewAccountDescription.registered_office_address_1"
            >
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold">Address Line 1:</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.registered_office_address_1 }}
              </div>
            </div>
            <div
              class="vx-row mb-6"
              v-if="viewAccountDescription.registered_office_address_2"
            >
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> Address Line 2: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.registered_office_address_2 }}
              </div>
            </div>
            <div
              class="vx-row mb-6"
              v-if="viewAccountDescription.registered_office_address_3"
            >
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> Address Line 3:</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.registered_office_address_3 }}
              </div>
            </div>
            <div
              class="vx-row mb-6"
              v-if="viewAccountDescription.registered_office_city"
            >
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> City: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.registered_office_city }}
              </div>
            </div>
            <div
              class="vx-row mb-6"
              v-if="viewAccountDescription.registered_office_county"
            >
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> County: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.registered_office_county }}
              </div>
            </div>
            <div
              class="vx-row mb-6"
              v-if="viewAccountDescription.registered_office_postcode"
            >
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> Postcode:</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.registered_office_postcode }}
              </div>
            </div>
            <div
              class="vx-row mb-6"
              v-if="viewAccountDescription.registered_office_country"
            >
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> Country:</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.registered_office_country }}
              </div>
            </div>

            <!-- Head Office -->
            <div
              v-if="
                viewAccountDescription.head_office_address_1 ||
                viewAccountDescription.head_office_address_2 ||
                viewAccountDescription.head_office_address_3 ||
                viewAccountDescription.head_office_city ||
                viewAccountDescription.head_office_county ||
                viewAccountDescription.head_office_postcode ||
                viewAccountDescription.head_office_country
              "
            >
              <vs-divider class="m-5" />
              <h5 class="mb-5 font-bold">Head Office Address</h5>
            </div>
            <div
              class="vx-row mb-6"
              v-if="viewAccountDescription.head_office_address_1"
            >
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> Address Line 1: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.head_office_address_1 }}
              </div>
            </div>
            <div
              class="vx-row mb-6"
              v-if="viewAccountDescription.head_office_address_2"
            >
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> Address Line 2: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.head_office_address_2 }}
              </div>
            </div>
            <div
              class="vx-row mb-6"
              v-if="viewAccountDescription.head_office_address_3"
            >
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> Address Line 3: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.head_office_address_3 }}
              </div>
            </div>
            <div
              class="vx-row mb-6"
              v-if="viewAccountDescription.head_office_city"
            >
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> City:</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.head_office_city }}
              </div>
            </div>
            <div
              class="vx-row mb-6"
              v-if="viewAccountDescription.head_office_county"
            >
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> County: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.head_office_county }}
              </div>
            </div>
            <div
              class="vx-row mb-6"
              v-if="viewAccountDescription.head_office_postcode"
            >
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> Postcode: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.head_office_postcode }}
              </div>
            </div>
            <div
              class="vx-row mb-6"
              v-if="viewAccountDescription.head_office_country"
            >
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> Country: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.head_office_country }}
              </div>
            </div>
            <!-- <vs-divider class="m-5" /> -->
            <template
              v-if="
                viewAccountDescription.web &&
                viewAccountDescription.web.length > 0
              "
            >
              <div class="vx-row p-5">
                <h6 class="mr-5 font-bold">Company Website(s)</h6>
              </div>
              <div
                v-for="(website, web_key) in viewAccountDescription.web"
                :key="web_key"
              >
                <span>
                  <p>{{ website.url }}</p>
                </span>
              </div>
              <vs-divider class="m-5" />
            </template>

            <template
              v-if="
                viewAccountDescription.linkedin &&
                viewAccountDescription.linkedin.length > 0
              "
            >
              <div class="vx-row p-5">
                <h6 class="mr-5 font-bold">Social Media Pages</h6>
              </div>
              <div
                v-for="(link, linkedin_key) in viewAccountDescription.linkedin"
                :key="linkedin_key"
              >
                <span>
                  <p>{{ link.url }}</p>
                </span>
              </div>
              <vs-divider class="m-5" />
            </template>

            <!-- Site Office -->
            <template
              v-if="
                viewAccountDescription.satellite_office &&
                viewAccountDescription.satellite_office.length > 0
              "
            >
              <h5 class="mb-5 font-bold">Site Office Address</h5>
              <template
                v-for="(site, index) in viewAccountDescription.satellite_office"
              >
                <div :key="index">
                  <vs-divider class="m-5" />
                  <h6 class="mb-5 font-bold">
                    {{ 'Satellite Office ' + (index + 1) }}
                  </h6>
                  <div class="vx-row mb-6" v-if="site.address_1">
                    <div class="vx-col sm:w-1/3 w-full">
                      <span class="font-bold"> Address Line 1:</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      {{ site.address_1 }}
                    </div>
                  </div>
                  <div class="vx-row mb-6" v-if="site.address_2">
                    <div class="vx-col sm:w-1/3 w-full">
                      <span class="font-bold"> Address Line 2:</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      {{ site.address_2 }}
                    </div>
                  </div>
                  <div class="vx-row mb-6" v-if="site.address_3">
                    <div class="vx-col sm:w-1/3 w-full">
                      <span class="font-bold"> Address Line 3:</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      {{ site.address_3 }}
                    </div>
                  </div>
                  <div class="vx-row mb-6" v-if="site.city">
                    <div class="vx-col sm:w-1/3 w-full">
                      <span class="font-bold"> City:</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">{{ site.city }}</div>
                  </div>
                  <div class="vx-row mb-6" v-if="site.county">
                    <div class="vx-col sm:w-1/3 w-full">
                      <span class="font-bold"> County:</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">{{ site.county }}</div>
                  </div>
                  <div class="vx-row mb-6" v-if="site.postcode">
                    <div class="vx-col sm:w-1/3 w-full">
                      <span class="font-bold"> Postcode:</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      {{ site.postcode }}
                    </div>
                  </div>
                  <div class="vx-row mb-6" v-if="site.country">
                    <div class="vx-col sm:w-1/3 w-full">
                      <span class="font-bold"> Country:</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">{{ site.country }}</div>
                  </div>
                  <div class="vx-row mb-6" v-if="site.phone.length != 0">
                    <div class="vx-col sm:w-1/3 w-full">
                      <span class="font-bold"> Telephone:</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      <template v-for="(phone, key) in site.phone">
                        <div
                          :key="key"
                          v-if="phone.satellite_office_id == site.id"
                        >
                          {{ phone.phone_code }} - {{ phone.phone_no }}
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </template>
              <vs-divider class="m-5" />
            </template>

            <!-- Telephone -->
            <template
              v-if="
                viewAccountDescription.phone &&
                viewAccountDescription.phone.length > 0
              "
            >
              <div class="vx-row p-5">
                <h6 class="mr-5 font-bold">Telephone Number(s)</h6>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col w-full">
                  <template v-for="phone in viewAccountDescription.phone">
                    <template v-for="p_type in phone.phone_type">
                      <template v-if="phone.id == p_type.phone_id">
                        <!-- <template v-if="p_type.type == 'head_office_switchboard'"> -->
                        <p class="m-2">
                          {{ p_type.type }} : {{ phone.phone_code
                          }}{{ phone.phone_no }}
                          <span
                            v-if="phone.checked_status == 'Registered'"
                            class="tps-registered"
                            style="font-size: 20px"
                            title="TPS Registered"
                            >®</span
                          >
                        </p>
                        <!-- </template>
                    <template v-if="p_type.type == 'customer_service'">
                      <p class="m-10">
                        Customer Service - {{ phone.phone_no }}
                      </p>
                    </template>

                    <template v-if="p_type.type == 'sales_line'">
                      <p class="m-10">Sales Line - {{ phone.phone_no }}</p>
                    </template>

                    <template v-if="p_type.type == 'customer_support_line'">
                      <p class="m-10">
                        Customer Support Line - {{ phone.phone_no }}
                      </p>
                    </template> -->
                      </template>
                    </template>
                  </template>
                </div>
                <div class="vx-col sm:w-2/3 w-full"></div>
              </div>
            </template>
            <!-- SIC CODE -->
            <template
              v-if="
                viewAccountDescription.sic_code &&
                viewAccountDescription.sic_code.length > 0
              "
            >
              <div class="vx-row p-5">
                <h6 class="mr-5 font-bold">Sic Code(s)</h6>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col w-full">
                  <template v-for="sic in viewAccountDescription.sic_code">
                    <p v-if="sic.sic_code_detail">
                      {{ sic.sic_code_detail.code }}
                      {{ ' - ' + sic.sic_code_detail.description }}
                    </p>
                  </template>
                </div>
                <div class="vx-col sm:w-2/3 w-full"></div>
              </div>
            </template>
            <template
              v-if="
                viewAccountDescription.registration_jurisdiction ||
                viewAccountDescription.parent ||
                viewAccountDescription.vertical
              "
            >
              <h5 class="mb-5">Other Details</h5>
              <div
                class="vx-row mb-6"
                v-if="viewAccountDescription.registration_jurisdiction"
              >
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Registration Jurisdiction:</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ RegistrationJurisdiction }}
                  <!-- {{ viewAccountDescription.registration_jurisdiction }} -->
                </div>
              </div>
              <div class="vx-row mb-6" v-if="viewAccountDescription.parent">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Parent:</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ parent_name }}
                </div>
              </div>
              <div class="vx-row mb-6" v-if="viewAccountDescription.vertical">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Vertical:</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <!-- {{ viewAccountDescription.vertical }} -->
                  {{ verticalName }}
                </div>
              </div>
            </template>
            <div class="vx-row mb-6" v-if="viewAccountDescription.revenue">
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> Revenue: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.currency_name }}
                {{ viewAccountDescription.revenue }}
              </div>
            </div>
            <div
              class="vx-row mb-6"
              v-if="viewAccountDescription.no_of_employees"
            >
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> No of Employees: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.no_of_employees }}
              </div>
            </div>
            <div class="vx-row mb-6" v-if="viewAccountDescription.notes">
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> Notes: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.notes }}
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/2 w-full">
                <span class="font-bold">Reason For Account Request * </span>
              </div>
              <div class="vx-col w-full mt-3">
                <vs-textarea
                  class="w-full"
                  v-model="match_account_reason_for_account_request"
                />
              </div>
            </div>

            <div class="text-center">
              <vs-button
                :disabled="
                  match_account_reason_for_account_request == null ||
                  match_account_reason_for_account_request.trim() == ''
                "
                class="mb-2"
                @click.prevent="matchSelectedAccountToRequestQA"
                >Submit</vs-button
              >
              <vs-button
                class="ml-5 mb-2"
                @click.prevent="cancelSelectedAccountDetails"
                >Cancel</vs-button
              >
            </div>
          </div>

          <vs-divider class="m-10" />
        </vs-col>
      </vs-row>

      <!-- <div>
        <vs-list>
          <template v-for="(match, index) in matched_websites">
            <vs-list-item :key="index">

              <p class="p-2">{{ match.company_name }}</p>
              <p class="p-2">{{ match.registered_office_country }}</p>
              <p class="p-2">
                {{ match.company_registration_number
                }}<vs-icon
                  @click.stop="viewAccountDetails(match.id)"
                  size="small"
                  icon="info"
                  style="cursor: pointer; margin-left: 15px"
                ></vs-icon>
              </p>
            </vs-list-item>
          </template>

          <div class="vx-row mt-5">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button @click="AddWebsiteAnyWay()" class="mr-3 mb-2"
                >Add Anyway</vs-button
              >

              <vs-button @click="CancelWebsitePopup()" class="mr-3 mb-2"
                >Cancel</vs-button
              >
            </div>
          </div>
        </vs-list>
      </div> -->
    </vs-popup>

    <vs-popup
      title="List of Accounts Matched By LinkedIn"
      :active.sync="MatchedLinkedInPopupActive"
      :fullscreen="showUpdateSAccountDetailsPopup"
       :button-close-hidden="true"
        @close="closeMatchedLinkedInPopup"
    >
      <vs-row vs-w="12" class="mb-5">
        <vs-col
          :vs-lg="showUpdateSAccountDetailsPopup ? 6 : 12"
          :vs-sm="showUpdateSAccountDetailsPopup ? 6 : 12"
          vs-xs="12"
        >
          <div class="text-center">
            <template v-for="(match, index) in matched_linkedins">
              <p class="p-2">{{ match.company_name }}</p>
              <p class="p-2">{{ match.registered_office_country }}</p>
              <p class="p-2">
                {{ match.company_registration_number
                }}<vs-icon
                  @click.stop="viewAccountDetails(match.id)"
                  size="small"
                  icon="info"
                  style="cursor: pointer; margin-left: 15px"
                ></vs-icon>
              </p>
            </template>
          </div>

          <div class="vx-row mt-5">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button @click="AddLinkedInAnyWay()" class="mr-3 mb-2"
                >Add Anyway</vs-button
              >

              <vs-button @click="CancelLinkedInPopup()" class="mr-3 mb-2"
                >Cancel</vs-button
              >
            </div>
          </div>
        </vs-col>

        <vs-col
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
          v-if="showUpdateSAccountDetailsPopup"
        >
          <u> <h4 class="font-bold text-lg mb-5">Account Details</h4></u>

          <div class="p-5">
            <div class="vx-row mb-6" v-if="viewAccountDescription.company_name">
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> Company Name: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.company_name }}
              </div>
            </div>
            <div
              class="vx-row mb-6"
              v-if="viewAccountDescription.actual_account_name"
            >
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> Actual Account Name: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.actual_account_name }}
              </div>
            </div>
            <div
              class="vx-row mb-6"
              v-if="viewAccountDescription.company_registration_number"
            >
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> Registration Number: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.company_registration_number }}
              </div>
            </div>

            <div class="vx-row mb-6" v-if="viewAccountDescription.status">
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> Company Status: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.status }}
              </div>
            </div>
            <div
              class="vx-row mb-6"
              v-if="viewAccountDescription.company_category"
            >
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> Company Category: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.company_category }}
              </div>
            </div>
            <div
              v-if="
                viewAccountDescription.registered_office_address_1 ||
                viewAccountDescription.registered_office_address_2 ||
                viewAccountDescription.registered_office_address_3 ||
                viewAccountDescription.registered_office_city ||
                viewAccountDescription.registered_office_county ||
                viewAccountDescription.registered_office_country ||
                viewAccountDescription.registered_office_country
              "
            >
              <vs-divider class="m-5" />
              <!-- Registered Office -->
              <h5 class="mb-5 font-bold">Registered Office Address</h5>
            </div>
            <div
              class="vx-row mb-6"
              v-if="viewAccountDescription.registered_office_address_1"
            >
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold">Address Line 1:</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.registered_office_address_1 }}
              </div>
            </div>
            <div
              class="vx-row mb-6"
              v-if="viewAccountDescription.registered_office_address_2"
            >
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> Address Line 2: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.registered_office_address_2 }}
              </div>
            </div>
            <div
              class="vx-row mb-6"
              v-if="viewAccountDescription.registered_office_address_3"
            >
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> Address Line 3:</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.registered_office_address_3 }}
              </div>
            </div>
            <div
              class="vx-row mb-6"
              v-if="viewAccountDescription.registered_office_city"
            >
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> City: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.registered_office_city }}
              </div>
            </div>
            <div
              class="vx-row mb-6"
              v-if="viewAccountDescription.registered_office_county"
            >
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> County: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.registered_office_county }}
              </div>
            </div>
            <div
              class="vx-row mb-6"
              v-if="viewAccountDescription.registered_office_postcode"
            >
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> Postcode:</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.registered_office_postcode }}
              </div>
            </div>
            <div
              class="vx-row mb-6"
              v-if="viewAccountDescription.registered_office_country"
            >
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> Country:</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.registered_office_country }}
              </div>
            </div>

            <!-- Head Office -->
            <div
              v-if="
                viewAccountDescription.head_office_address_1 ||
                viewAccountDescription.head_office_address_2 ||
                viewAccountDescription.head_office_address_3 ||
                viewAccountDescription.head_office_city ||
                viewAccountDescription.head_office_county ||
                viewAccountDescription.head_office_postcode ||
                viewAccountDescription.head_office_country
              "
            >
              <vs-divider class="m-5" />
              <h5 class="mb-5 font-bold">Head Office Address</h5>
            </div>
            <div
              class="vx-row mb-6"
              v-if="viewAccountDescription.head_office_address_1"
            >
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> Address Line 1: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.head_office_address_1 }}
              </div>
            </div>
            <div
              class="vx-row mb-6"
              v-if="viewAccountDescription.head_office_address_2"
            >
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> Address Line 2: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.head_office_address_2 }}
              </div>
            </div>
            <div
              class="vx-row mb-6"
              v-if="viewAccountDescription.head_office_address_3"
            >
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> Address Line 3: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.head_office_address_3 }}
              </div>
            </div>
            <div
              class="vx-row mb-6"
              v-if="viewAccountDescription.head_office_city"
            >
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> City:</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.head_office_city }}
              </div>
            </div>
            <div
              class="vx-row mb-6"
              v-if="viewAccountDescription.head_office_county"
            >
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> County: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.head_office_county }}
              </div>
            </div>
            <div
              class="vx-row mb-6"
              v-if="viewAccountDescription.head_office_postcode"
            >
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> Postcode: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.head_office_postcode }}
              </div>
            </div>
            <div
              class="vx-row mb-6"
              v-if="viewAccountDescription.head_office_country"
            >
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> Country: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.head_office_country }}
              </div>
            </div>
            <!-- <vs-divider class="m-5" /> -->
            <template
              v-if="
                viewAccountDescription.web &&
                viewAccountDescription.web.length > 0
              "
            >
              <div class="vx-row p-5">
                <h6 class="mr-5 font-bold">Company Website(s)</h6>
              </div>
              <div
                v-for="(website, web_key) in viewAccountDescription.web"
                :key="web_key"
              >
                <span>
                  <p>{{ website.url }}</p>
                </span>
              </div>
              <vs-divider class="m-5" />
            </template>

            <template
              v-if="
                viewAccountDescription.linkedin &&
                viewAccountDescription.linkedin.length > 0
              "
            >
              <div class="vx-row p-5">
                <h6 class="mr-5 font-bold">Social Media Pages</h6>
              </div>
              <div
                v-for="(link, linkedin_key) in viewAccountDescription.linkedin"
                :key="linkedin_key"
              >
                <span>
                  <p>{{ link.url }}</p>
                </span>
              </div>
              <vs-divider class="m-5" />
            </template>

            <!-- Site Office -->
            <template
              v-if="
                viewAccountDescription.satellite_office &&
                viewAccountDescription.satellite_office.length > 0
              "
            >
              <h5 class="mb-5 font-bold">Site Office Address</h5>
              <template
                v-for="(site, index) in viewAccountDescription.satellite_office"
              >
                <div :key="index">
                  <vs-divider class="m-5" />
                  <h6 class="mb-5 font-bold">
                    {{ 'Satellite Office ' + (index + 1) }}
                  </h6>
                  <div class="vx-row mb-6" v-if="site.address_1">
                    <div class="vx-col sm:w-1/3 w-full">
                      <span class="font-bold"> Address Line 1:</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      {{ site.address_1 }}
                    </div>
                  </div>
                  <div class="vx-row mb-6" v-if="site.address_2">
                    <div class="vx-col sm:w-1/3 w-full">
                      <span class="font-bold"> Address Line 2:</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      {{ site.address_2 }}
                    </div>
                  </div>
                  <div class="vx-row mb-6" v-if="site.address_3">
                    <div class="vx-col sm:w-1/3 w-full">
                      <span class="font-bold"> Address Line 3:</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      {{ site.address_3 }}
                    </div>
                  </div>
                  <div class="vx-row mb-6" v-if="site.city">
                    <div class="vx-col sm:w-1/3 w-full">
                      <span class="font-bold"> City:</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">{{ site.city }}</div>
                  </div>
                  <div class="vx-row mb-6" v-if="site.county">
                    <div class="vx-col sm:w-1/3 w-full">
                      <span class="font-bold"> County:</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">{{ site.county }}</div>
                  </div>
                  <div class="vx-row mb-6" v-if="site.postcode">
                    <div class="vx-col sm:w-1/3 w-full">
                      <span class="font-bold"> Postcode:</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      {{ site.postcode }}
                    </div>
                  </div>
                  <div class="vx-row mb-6" v-if="site.country">
                    <div class="vx-col sm:w-1/3 w-full">
                      <span class="font-bold"> Country:</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">{{ site.country }}</div>
                  </div>
                  <div class="vx-row mb-6" v-if="site.phone.length != 0">
                    <div class="vx-col sm:w-1/3 w-full">
                      <span class="font-bold"> Telephone:</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      <template v-for="(phone, key) in site.phone">
                        <div
                          :key="key"
                          v-if="phone.satellite_office_id == site.id"
                        >
                          {{ phone.phone_code }} - {{ phone.phone_no }}
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </template>
              <vs-divider class="m-5" />
            </template>

            <!-- Telephone -->
            <template
              v-if="
                viewAccountDescription.phone &&
                viewAccountDescription.phone.length > 0
              "
            >
              <div class="vx-row p-5">
                <h6 class="mr-5 font-bold">Telephone Number(s)</h6>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col w-full">
                  <template v-for="phone in viewAccountDescription.phone">
                    <template v-for="p_type in phone.phone_type">
                      <template v-if="phone.id == p_type.phone_id">
                        <!-- <template v-if="p_type.type == 'head_office_switchboard'"> -->
                        <p class="m-2">
                          {{ p_type.type }} : {{ phone.phone_code
                          }}{{ phone.phone_no }}
                          <span
                            v-if="phone.checked_status == 'Registered'"
                            class="tps-registered"
                            style="font-size: 20px"
                            title="TPS Registered"
                            >®</span
                          >
                        </p>
                        <!-- </template>
                    <template v-if="p_type.type == 'customer_service'">
                      <p class="m-10">
                        Customer Service - {{ phone.phone_no }}
                      </p>
                    </template>

                    <template v-if="p_type.type == 'sales_line'">
                      <p class="m-10">Sales Line - {{ phone.phone_no }}</p>
                    </template>

                    <template v-if="p_type.type == 'customer_support_line'">
                      <p class="m-10">
                        Customer Support Line - {{ phone.phone_no }}
                      </p>
                    </template> -->
                      </template>
                    </template>
                  </template>
                </div>
                <div class="vx-col sm:w-2/3 w-full"></div>
              </div>
            </template>
            <!-- SIC CODE -->
            <template
              v-if="
                viewAccountDescription.sic_code &&
                viewAccountDescription.sic_code.length > 0
              "
            >
              <div class="vx-row p-5">
                <h6 class="mr-5 font-bold">Sic Code(s)</h6>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col w-full">
                  <template v-for="sic in viewAccountDescription.sic_code">
                    <p v-if="sic.sic_code_detail">
                      {{ sic.sic_code_detail.code }}
                      {{ ' - ' + sic.sic_code_detail.description }}
                    </p>
                  </template>
                </div>
                <div class="vx-col sm:w-2/3 w-full"></div>
              </div>
            </template>
            <template
              v-if="
                viewAccountDescription.registration_jurisdiction ||
                viewAccountDescription.parent ||
                viewAccountDescription.vertical
              "
            >
              <h5 class="mb-5">Other Details</h5>
              <div
                class="vx-row mb-6"
                v-if="viewAccountDescription.registration_jurisdiction"
              >
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Registration Jurisdiction:</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ RegistrationJurisdiction }}
                  <!-- {{ viewAccountDescription.registration_jurisdiction }} -->
                </div>
              </div>
              <div class="vx-row mb-6" v-if="viewAccountDescription.parent">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Parent:</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  {{ parent_name }}
                </div>
              </div>
              <div class="vx-row mb-6" v-if="viewAccountDescription.vertical">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Vertical:</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <!-- {{ viewAccountDescription.vertical }} -->
                  {{ verticalName }}
                </div>
              </div>
            </template>
            <div class="vx-row mb-6" v-if="viewAccountDescription.revenue">
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> Revenue: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.currency_name }}
                {{ viewAccountDescription.revenue }}
              </div>
            </div>
            <div
              class="vx-row mb-6"
              v-if="viewAccountDescription.no_of_employees"
            >
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> No of Employees: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.no_of_employees }}
              </div>
            </div>
            <div class="vx-row mb-6" v-if="viewAccountDescription.notes">
              <div class="vx-col sm:w-1/3 w-full">
                <span class="font-bold"> Notes: </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ viewAccountDescription.notes }}
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/2 w-full">
                <span class="font-bold">Reason For Account Request * </span>
              </div>
              <div class="vx-col w-full mt-3">
                <vs-textarea
                  class="w-full"
                  v-model="match_account_reason_for_account_request"
                />
              </div>
            </div>

            <div class="text-center">
              <vs-button
                :disabled="
                  match_account_reason_for_account_request == null ||
                  match_account_reason_for_account_request.trim() == ''
                "
                class="mb-2"
                @click.prevent="matchSelectedAccountToRequestQA"
                >Submit</vs-button
              >
              <vs-button
                class="ml-5 mb-2"
                @click.prevent="cancelSelectedAccountDetails"
                >Cancel</vs-button
              >
            </div>
          </div>

          <vs-divider class="m-10" />
        </vs-col>
      </vs-row>
    </vs-popup>

    <vs-popup
      title="This account matches other accounts in the master database"
      :active.sync="MatchedAccountsPopupActive"
    >
      <div>
        <vs-list>
          <template v-for="(match, index) in submit_match_accounts">
            <vs-list-item :key="index">
              <p class="p-2">{{ match.company_name }}</p>
              <p class="p-2">{{ match.registered_office_country }}</p>
              <p class="p-2">
                {{ match.company_registration_number
                }}<vs-icon
                  @click.stop="viewPotentialMatchAccountDetails(match)"
                  size="small"
                  icon="info"
                  style="cursor: pointer; margin-left: 15px"
                ></vs-icon>
              </p>
            </vs-list-item>
          </template>

          <div class="vx-row mt-5"></div>
        </vs-list>
      </div>
    </vs-popup>

    <vs-popup
      fullscreen
      title="This account matches an account in the master database, please review the details and confirm if you want to request this account"
      v-if="showUpdateSAccountDetailsPopup"
      :active.sync="updateAccountDetailsPopupActive"
      :button-close-hidden="true"
      @close="closeshowUpdateSAccountDetailsPopup()"
    >
      <div class="p-5">
        <div class="vx-row mb-6" v-if="viewAccountDescription.company_name">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"> Company Name: </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.company_name }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="viewAccountDescription.actual_account_name"
        >
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"> Actual Account Name: </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.actual_account_name }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="viewAccountDescription.company_registration_number"
        >
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"> Registration Number: </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.company_registration_number }}
          </div>
        </div>

        <div class="vx-row mb-6" v-if="viewAccountDescription.status">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"> Company Status: </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.status }}
          </div>
        </div>
        <div class="vx-row mb-6" v-if="viewAccountDescription.company_category">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"> Company Category: </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.company_category }}
          </div>
        </div>
        <div
          v-if="
            viewAccountDescription.registered_office_address_1 ||
            viewAccountDescription.registered_office_address_2 ||
            viewAccountDescription.registered_office_address_3 ||
            viewAccountDescription.registered_office_city ||
            viewAccountDescription.registered_office_county ||
            viewAccountDescription.registered_office_country ||
            viewAccountDescription.registered_office_country
          "
        >
          <vs-divider class="m-5" />
          <!-- Registered Office -->
          <h5 class="mb-5 font-bold">Registered Office Address</h5>
        </div>
        <div
          class="vx-row mb-6"
          v-if="viewAccountDescription.registered_office_address_1"
        >
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold">Address Line 1:</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.registered_office_address_1 }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="viewAccountDescription.registered_office_address_2"
        >
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"> Address Line 2: </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.registered_office_address_2 }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="viewAccountDescription.registered_office_address_3"
        >
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"> Address Line 3:</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.registered_office_address_3 }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="viewAccountDescription.registered_office_city"
        >
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"> City: </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.registered_office_city }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="viewAccountDescription.registered_office_county"
        >
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"> County: </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.registered_office_county }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="viewAccountDescription.registered_office_postcode"
        >
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"> Postcode:</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.registered_office_postcode }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="viewAccountDescription.registered_office_country"
        >
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"> Country:</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.registered_office_country }}
          </div>
        </div>

        <!-- Head Office -->
        <div
          v-if="
            viewAccountDescription.head_office_address_1 ||
            viewAccountDescription.head_office_address_2 ||
            viewAccountDescription.head_office_address_3 ||
            viewAccountDescription.head_office_city ||
            viewAccountDescription.head_office_county ||
            viewAccountDescription.head_office_postcode ||
            viewAccountDescription.head_office_country
          "
        >
          <vs-divider class="m-5" />
          <h5 class="mb-5 font-bold">Head Office Address</h5>
        </div>
        <div
          class="vx-row mb-6"
          v-if="viewAccountDescription.head_office_address_1"
        >
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"> Address Line 1: </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.head_office_address_1 }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="viewAccountDescription.head_office_address_2"
        >
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"> Address Line 2: </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.head_office_address_2 }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="viewAccountDescription.head_office_address_3"
        >
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"> Address Line 3: </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.head_office_address_3 }}
          </div>
        </div>
        <div class="vx-row mb-6" v-if="viewAccountDescription.head_office_city">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"> City:</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.head_office_city }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="viewAccountDescription.head_office_county"
        >
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"> County: </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.head_office_county }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="viewAccountDescription.head_office_postcode"
        >
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"> Postcode: </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.head_office_postcode }}
          </div>
        </div>
        <div
          class="vx-row mb-6"
          v-if="viewAccountDescription.head_office_country"
        >
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"> Country: </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.head_office_country }}
          </div>
        </div>
        <!-- <vs-divider class="m-5" /> -->
        <template
          v-if="
            viewAccountDescription.web && viewAccountDescription.web.length > 0
          "
        >
          <div class="vx-row p-5">
            <h6 class="mr-5 font-bold">Company Website(s)</h6>
          </div>
          <div
            v-for="(website, web_key) in viewAccountDescription.web"
            :key="web_key"
          >
            <span>
              <p>{{ website.url }}</p>
            </span>
          </div>
          <vs-divider class="m-5" />
        </template>

        <template
          v-if="
            viewAccountDescription.linkedin &&
            viewAccountDescription.linkedin.length > 0
          "
        >
          <div class="vx-row p-5">
            <h6 class="mr-5 font-bold">Social Media Pages</h6>
          </div>
          <div
            v-for="(link, linkedin_key) in viewAccountDescription.linkedin"
            :key="linkedin_key"
          >
            <span>
              <p>{{ link.url }}</p>
            </span>
          </div>
          <vs-divider class="m-5" />
        </template>

        <!-- Site Office -->
        <template
          v-if="
            viewAccountDescription.satellite_office &&
            viewAccountDescription.satellite_office.length > 0
          "
        >
          <h5 class="mb-5 font-bold">Site Office Address</h5>
          <template
            v-for="(site, index) in viewAccountDescription.satellite_office"
          >
            <div :key="index">
              <vs-divider class="m-5" />
              <h6 class="mb-5 font-bold">
                {{ 'Satellite Office ' + (index + 1) }}
              </h6>
              <div class="vx-row mb-6" v-if="site.address_1">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Address Line 1:</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">{{ site.address_1 }}</div>
              </div>
              <div class="vx-row mb-6" v-if="site.address_2">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Address Line 2:</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">{{ site.address_2 }}</div>
              </div>
              <div class="vx-row mb-6" v-if="site.address_3">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Address Line 3:</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">{{ site.address_3 }}</div>
              </div>
              <div class="vx-row mb-6" v-if="site.city">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> City:</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">{{ site.city }}</div>
              </div>
              <div class="vx-row mb-6" v-if="site.county">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> County:</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">{{ site.county }}</div>
              </div>
              <div class="vx-row mb-6" v-if="site.postcode">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Postcode:</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">{{ site.postcode }}</div>
              </div>
              <div class="vx-row mb-6" v-if="site.country">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Country:</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">{{ site.country }}</div>
              </div>
              <div class="vx-row mb-6" v-if="site.phone.length != 0">
                <div class="vx-col sm:w-1/3 w-full">
                  <span class="font-bold"> Telephone:</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <template v-for="(phone, key) in site.phone">
                    <div :key="key" v-if="phone.satellite_office_id == site.id">
                      {{ phone.phone_code }} - {{ phone.phone_no }}
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </template>
          <vs-divider class="m-5" />
        </template>

        <!-- Telephone -->
        <template
          v-if="
            viewAccountDescription.phone &&
            viewAccountDescription.phone.length > 0
          "
        >
          <div class="vx-row p-5">
            <h6 class="mr-5 font-bold">Telephone Number(s)</h6>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <template v-for="phone in viewAccountDescription.phone">
                <template v-for="p_type in phone.phone_type">
                  <template v-if="phone.id == p_type.phone_id">
                    <!-- <template v-if="p_type.type == 'head_office_switchboard'"> -->
                    <p class="m-2">
                      {{ p_type.type }} : {{ phone.phone_code
                      }}{{ phone.phone_no }}
                      <span
                            v-if="phone.checked_status == 'Registered'"
                            class="tps-registered"
                            style="font-size: 20px"
                            title="TPS Registered"
                            >®</span
                      >
                    </p>
                  </template>
                </template>
              </template>
            </div>
            <div class="vx-col sm:w-2/3 w-full"></div>
          </div>
        </template>
        <!-- SIC CODE -->
        <template
          v-if="
            viewAccountDescription.sic_code &&
            viewAccountDescription.sic_code.length > 0
          "
        >
          <div class="vx-row p-5">
            <h6 class="mr-5 font-bold">Sic Code(s)</h6>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <template v-for="sic in viewAccountDescription.sic_code">
                <p v-if="sic.sic_code_detail">
                  {{ sic.sic_code_detail.code }}
                  {{ ' - ' + sic.sic_code_detail.description }}
                </p>
              </template>
            </div>
            <div class="vx-col sm:w-2/3 w-full"></div>
          </div>
        </template>
        <template
          v-if="
            viewAccountDescription.registration_jurisdiction ||
            viewAccountDescription.parent ||
            viewAccountDescription.vertical
          "
        >
          <h5 class="mb-5">Other Details</h5>
          <div
            class="vx-row mb-6"
            v-if="viewAccountDescription.registration_jurisdiction"
          >
            <div class="vx-col sm:w-1/3 w-full">
              <span class="font-bold"> Registration Jurisdiction:</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              {{ RegistrationJurisdiction }}
              <!-- {{ viewAccountDescription.registration_jurisdiction }} -->
            </div>
          </div>
          <div class="vx-row mb-6" v-if="viewAccountDescription.parent">
            <div class="vx-col sm:w-1/3 w-full">
              <span class="font-bold"> Parent:</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              {{ parent_name }}
            </div>
          </div>
          <div class="vx-row mb-6" v-if="viewAccountDescription.vertical">
            <div class="vx-col sm:w-1/3 w-full">
              <span class="font-bold"> Vertical:</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <!-- {{ viewAccountDescription.vertical }} -->
              {{ verticalName }}
            </div>
          </div>
        </template>
        <div class="vx-row mb-6" v-if="viewAccountDescription.revenue">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"> Revenue: </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.currency_name }}
            {{ viewAccountDescription.revenue }}
          </div>
        </div>
        <div class="vx-row mb-6" v-if="viewAccountDescription.no_of_employees">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"> No of Employees: </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.no_of_employees }}
          </div>
        </div>
        <div class="vx-row mb-6" v-if="viewAccountDescription.notes">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-bold"> Notes: </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ viewAccountDescription.notes }}
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/2 w-full">
            <span class="font-bold">Reason For Account Request * </span>
          </div>
          <div class="vx-col w-full mt-3">
            <vs-textarea
              class="w-full"
              v-model="match_account_reason_for_account_request"
            />
          </div>
        </div>

        <div class="text-center">
          <vs-button
            :disabled="
              match_account_reason_for_account_request == null ||
              match_account_reason_for_account_request.trim() == ''
            "
            class="mb-2"
            @click.prevent="matchSelectedAccountToRequestQA"
            >Submit</vs-button
          >
          <vs-button
            class="ml-5 mb-2"
            @click.prevent="cancelSelectedAccountDetails"
            >Cancel</vs-button
          >
        </div>
      </div>
    </vs-popup>

    <vx-card class="vxtable" v-if="searchAccountForm">
      <div class="vx-row mb-3">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Search Account:</span>
        </div>
        <div class="vx-col sm:w-1/3 w-full">
          <AccountAutocomplete
            :key="companySearchComponentKey"
            class="searchbox"
            :list="searchAccount"
            :searchOn="'company_or_registration_no'"
            @event-name="handleChildEvent"
          ></AccountAutocomplete>
          {{ contactDescription.company_name }}
        </div>

        <vs-icon
          @click.stop="showAddAccountForm"
          size="medium"
          icon="⊞"
          style="cursor: pointer; margin-left: 5px"
        ></vs-icon>
      </div>
    </vx-card>

    <vx-card class="vxtable" v-if="addAccountForm">
      <form>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Website URLs:</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  class="w-full"
                  name="website_url"
                  v-validate="'url:require_protocol'"
                  v-model="accounts.web"
                  data-vv-as="website"
                />
              </div>

              <div class="vx-col sm:w-1/2 w-full">
                <vs-button @click="addWebsite" color="primary" type="filled"
                  >Check & Add</vs-button
                >
                <span
                  class="text-danger text-sm mt-2 ml-16"
                  v-show="errors.has('website_url')"
                  >{{ errors.first('website_url') }}</span
                >
              </div>
            </div>

            <template v-for="website in accountDescription.web">
              <span class="p-2">
                <p>
                  {{ website.url }}
                  <vs-icon
                    class="ml-10 removeButton"
                    @click="removeSelectedWeb(website)"
                    color="success"
                    icon="clear"
                  ></vs-icon>
                </p>
              </span>
            </template>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Social Media Pages:</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  class="w-full"
                  name="linkedin"
                  v-model="accounts.linkedin"
                />
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-button
                  color="primary"
                  @click="addLinkedin"
                  v-validate="'url:require_protocol'"
                  type="filled"
                  >Check & Add</vs-button
                >
                <span
                  class="text-danger text-sm mt-2 ml-16"
                  v-show="errors.has('linkedin')"
                  >{{ errors.first('linkedin') }}</span
                >
              </div>
            </div>
            <template v-for="link in accountDescription.linkedin">
              <span class="p-2">
                <p>
                  {{ link.url }}
                  <vs-icon
                    class="ml-10 removeButton"
                    @click="removeSelectedLinkedin(link)"
                    color="success"
                    icon="clear"
                  ></vs-icon>
                </p>
              </span>
            </template>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Company Name:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-input
              class="w-full"
              name="company_name"
              v-model="accountDescription.company_name"
              v-validate="'required'"
              data-vv-as="Company Name"
            />
          </div>
          <span
            class="text-danger text-sm mt-2 ml-16"
            v-show="errors.has('company_name')"
            >{{ errors.first('company_name') }}</span
          >
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Registered Office Country:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <AccountAutocomplete
              ref="accountEditRegisteredOfficeCountryRef"
              :chosen="selected_registered_office_country"
              class="searchbox"
              :list="getCountries"
              :searchOn="'registered_office_country'"
            >
            </AccountAutocomplete>
          </div>
          <span
            v-if="registered_office_country_validation"
            class="text-danger text-sm mt-2 ml-16"
            >{{ registered_office_country_validation }}</span
          >
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Company Registration Number:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-input
              class="w-full"
              name="company_registration_number"
              v-model="accountDescription.company_registration_number"
              data-vv-as="Company Registration Number"
            />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Company Status:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-input
              class="w-full"
              name="company_status"
              v-model="accountDescription.status"
              data-vv-as="Company Status"
            />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Company Category:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-input
              class="w-full"
              name="company_category"
              v-model="accountDescription.company_category"
              data-vv-as="Company Category"
            />
          </div>
        </div>

        <!-- Registered Office -->
        <h5 class="mb-5">Registered Office Address</h5>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Address Line 1:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-input
              class="w-full"
              name="registered_office_address_1"
              v-model="accountDescription.registered_office_address_1"
            />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Address Line 2:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-input
              class="w-full"
              v-model="accountDescription.registered_office_address_2"
            />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Address Line 3:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-input
              class="w-full"
              v-model="accountDescription.registered_office_address_3"
            />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>City:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-input
              class="w-full"
              v-model="accountDescription.registered_office_city"
            />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>County:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-input
              class="w-full"
              v-model="accountDescription.registered_office_county"
            />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Postcode:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-input
              class="w-full"
              v-model="accountDescription.registered_office_postcode"
            />
          </div>
        </div>

        <!-- Head Office -->
        <h5 class="mb-5">Head Office Address</h5>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span
              >Head Office Address is the Same As the Registered Office
              Address:</span
            >
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-switch
              vs-icon-on="check_box"
              vs-icon-off="block"
              v-model="headOfficeIsRegisteredOffice"
            >
              <span slot="on">YES</span>
              <span slot="off">NO</span>
            </vs-switch>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Address Line 1:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-input
              class="w-full"
              v-model="accountDescription.head_office_address_1"
              name="head_office_address_1"
            />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Address Line 2:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-input
              class="w-full"
              v-model="accountDescription.head_office_address_2"
            />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Address Line 3:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-input
              class="w-full"
              v-model="accountDescription.head_office_address_3"
            />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>City:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-input
              class="w-full"
              name="head_office_city"
              v-model="accountDescription.head_office_city"
            />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>County:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-input
              class="w-full"
              v-model="accountDescription.head_office_county"
            />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Postcode:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-input
              class="w-full"
              v-model="accountDescription.head_office_postcode"
            />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Country:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <AccountAutocomplete
              ref="accountEditHeadOfficeCountryRef"
              :chosen="selected_head_office_country"
              class="searchbox"
              :list="getCountries"
              :searchOn="'head_office_country'"
            >
            </AccountAutocomplete>

           
          </div>
          <span
            v-if="head_office_country_validation"
            class="text-danger text-sm mt-2 ml-16"
            >{{ head_office_country_validation }}</span
          >
        </div>

        <!-- Site Office -->
        <h5 class="mb-5">Site Office Address</h5>
        <template v-for="(site, index) in accountDescription.satellite_office">
          <div :key="index">
            <vs-divider class="m-5" />
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Address Line 1:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input
                  class="w-full"
                  name="satellite_office_address_1"
                  data-vv-as="Address Line 1"
                  v-model="site.address_1"
                />
              </div>
              <vs-icon
                class="ml-10 removeButton"
                @click="removeSelectedSiteAddress(site)"
                color="success"
                icon="clear"
              ></vs-icon>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Address Line 2:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" v-model="site.address_2" />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Address Line 3:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" v-model="site.address_3" />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>City:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" v-model="site.city" />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>County:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" v-model="site.county" />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Postcode:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" v-model="site.postcode" />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Telephone:</span>
              </div>
              <div class="vx-col sm:w-1/2 w-full" v-if="site.phone != null">
                <div v-if="site.phone.length != 0">
                  <template v-for="(site_ph, ph_index) in site.phone">
                    <div
                      :key="ph_index"
                      v-if="site_ph.satellite_office_id == site.id"
                    >
                      <div class="vx-row">
                        <div class="vx-col sm:w-1/3 w-full">
                          <v-select
                            name="phone_code"
                            class="phone_code"
                            label="name_with_code"
                            :options="all_phone_codes"
                            :dir="$vs.rtl ? 'rtl' : 'ltr'"
                            v-model="site_ph.phone_code"
                          />
                        </div>
                        <div class="vx-col sm:w-1/3 w-full">
                          <vs-input
                            @input="
                              site_ph.phone_no = site_ph.phone_no
                                .replace(/[^0-9.]/g, '')
                                .replace(/(\..*?)\..*/g, '$1')
                            "
                            class="w-full"
                            v-model="site_ph.phone_no"
                          />
                        </div>
                      </div>
                    </div>
                  </template>
                </div>

                <div class="vx-col w-full" v-else>
                  <div class="vx-row">
                    <div class="vx-col sm:w-1/3 w-full">
                      <v-select
                        name="phone_code"
                        class="phone_code"
                        label="name_with_code"
                        :options="all_phone_codes"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-model="site.phone_code"
                      />
                    </div>
                    <div class="vx-col sm:w-1/3 w-full">
                      <vs-input
                        class="w-full"
                        @input="
                          site.phone_no = site.phone_no
                            .replace(/[^0-9.]/g, '')
                            .replace(/(\..*?)\..*/g, '$1')
                        "
                        v-model="site.phone_no"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="vx-col sm:w-1/2 w-full" v-else>
                <div class="vx-row">
                  <div class="vx-col sm:w-1/3 w-full">
                    <v-select
                      name="phone_code"
                      class="phone_code"
                      label="name_with_code"
                      :options="all_phone_codes"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      v-model="site.phone_code"
                    />
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <vs-input
                      class="w-full"
                      @input="
                        site.phone_no = site.phone_no
                          .replace(/[^0-9.]/g, '')
                          .replace(/(\..*?)\..*/g, '$1')
                      "
                      v-model="site.phone_no"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <vs-col
          class="mb-5"
          vs-offset="4"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="4"
        >
          <vs-button color="primary" @click="addSiteOffice" type="filled"
            >Add Satellite Office</vs-button
          >
        </vs-col>

        <vs-divider class="m-5" />
        <!-- Telephone -->
        <div class="vx-row">
          <h6 class="p-5">Telephone Number(s)</h6>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full">
            <v-select
              name="phone_code"
              class="phone_code"
              label="name_with_code"
              :options="all_phone_codes"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="accounts.phone_code"
            />
          </div>
          <div class="vx-col sm:w-1/5 w-full">
            <vs-input
              @input="
                accounts.phone = accounts.phone
                  .replace(/[^0-9.]/g, '')
                  .replace(/(\..*?)\..*/g, '$1')
              "
              class="w-full"
              v-model="accounts.phone"
            />
          </div>
          <div class="vx-col sm:w-1/5 w-full">
            <v-select
              label="name"
              :options="accounts.phoneTypes"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="accounts.phoneType"
            />
          </div>
          <div class="vx-col sm:w-1/5 w-full">
            <vs-button color="primary" @click="addPhoneNumbers" type="filled"
              >Check & Add</vs-button
            >
          </div>
        </div>
        <template v-for="phoneAndType in accounts.joinedPhoneAndTypes">
          <p class="m-10">
            {{ phoneAndType }}
            <vs-icon
              class="ml-10 removeButton"
              @click="removeNewSelectedPhone(phoneAndType)"
              color="success"
              icon="clear"
            ></vs-icon>
          </p>
        </template>
        <template
          v-if="accountDescription.phone && accountDescription.phone.length > 0"
        >
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <template v-for="phone in accountDescription.phone">
                <template v-for="p_type in phone.phone_type">
                  <template v-if="phone.id == p_type.phone_id">
                    <p class="m-10">
                      {{ p_type.type }} : {{ phone.phone_code
                      }}{{ phone.phone_no }}
                      <vs-icon
                        class="ml-10 removeButton"
                        @click="removeSelectedPhone(phone)"
                        color="success"
                        icon="clear"
                      ></vs-icon>
                    </p>
                  </template>
                </template>
              </template>
            </div>
            <div class="vx-col sm:w-1/3 w-full"></div>
          </div>
        </template>
        <!-- Sic Code -->
        <div class="vx-row">
          <h6 class="p-5">Sic Codes(s)</h6>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <AccountAutocomplete
              ref="SicCodeRefEdit"
              class="searchbox"
              :chosen="selected_sic_code"
              :list="getSicCodes"
              :searchOn="'sic_codes'"
            ></AccountAutocomplete>
          
          </div>

          <div class="vx-col sm:w-1/3 w-full">
            <vs-button color="primary" @click="addSicCodes" type="filled"
              >Check & Add</vs-button
            >
          </div>
        </div>
        <template v-for="sic in accounts.joinedSicAndDescription">
          <p class="m-10">
            {{ sic.name }}
            <vs-icon
              class="ml-10 removeButton"
              @click="removeNewSelectedSicCode(sic)"
              color="success"
              icon="clear"
            ></vs-icon>
          </p>
        </template>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Registration Jurisdiction:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <AccountAutocomplete
              ref="EditAccountRegistrationJurisdictionRef"
              :chosen="selected_registration_jurisdiction"
              class="searchbox"
              :list="getCountries"
              :searchOn="'registration_jurisdiction'"
            >
            </AccountAutocomplete>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Parent Company:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <AccountAutocomplete
              ref="EditAccountParentRef"
              class="searchbox"
              :list="getParentCompany"
              :searchOn="'parent'"
            >
            </AccountAutocomplete>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Vertical:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <AccountAutocomplete
              ref="EditAccountVerticalRef"
              class="searchbox"
              :chosen="selected_vertical"
              :list="getVerticals"
              :searchOn="'vertical'"
            ></AccountAutocomplete>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Revenue:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <v-select
                  label="label"
                  :options="currencyCodes"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  v-model="accountDescription.currency_code"
                />
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input
                  type="number"
                  class="w-full"
                  v-model="accountDescription.revenue"
                />
              </div>
            </div>
            <span
              v-if="currency_code_validation"
              class="text-danger text-sm mt-2 ml-16"
              >{{ currency_code_validation }}</span
            >
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>No. of Employees:</span>
          </div>
          <div class="vx-col sm:w-1/6 w-full">
            <vs-input
              type="number"
              class="w-full"
              v-model="accountDescription.no_of_employees"
            />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Notes:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-textarea class="w-full" v-model="accountDescription.notes" />
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Reason For Account Request</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-textarea
              class="w-full"
              v-validate="'required'"
              data-vv-as="Reason For Account Request"
              name="reason_for_account_request"
              v-model="accountDescription.reason_for_account_request"
            />
          </div>
          <span
            class="text-danger text-sm mt-2 ml-16"
            v-show="errors.has('reason_for_account_request')"
            >{{ errors.first('reason_for_account_request') }}</span
          >
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full"></div>

          <div class="vx-col sm:w-1/3 w-full">
            <vs-button class="mr-3 mb-2" @click.prevent="submitAccountForm"
              >Submit</vs-button
            >
          </div>
        </div>
      </form>
    </vx-card>

    <vs-popup
      fullscreen
      title="Add Contact To This Account On Campaign"
      :active.sync="AddContactToThisAccountOnCampaignPopupPopupActive"
      :button-close-hidden="true"
      @close="closeAddContactToThisAccountOnCampaignPopupPopup()"
    >
      <div>
        <div class="vx-row mb-3" v-if="viewAccountDescription.id != undefined">
          <div class="vx-col sm:w-1/2 w-full">


            





            <div class="text-center mb-5">

                        <h6 class="mb-3">Master DB Contacts</h6>    

             <h6>
Company : {{ viewAccountDescription.company_name }}
             </h6> 
            </div>

            <div
              :class="all_existing_db_contacts.length > 0 ? scrollClass2 : ''"
            >
              <template v-for="(match, index) in all_existing_db_contacts">
                <p class="p-3">
                  <vs-radio
                    v-model="selected_all_existing_database_contacts"
                    :vs-value="match"
                    class="mr-4"
                    vs-name="theme-mode-dark"
                  >
                    {{ match.title }} {{ match.forename }} {{ match.surname }} -
                    {{ match.job_title }}
                  </vs-radio>
                </p>
              </template>

              <div
                class="vx-row mb-6"
              >
                <div class="vx-col w-full ml-6 mt-5">
                  <vs-button
                    :disabled="selected_all_existing_database_contacts == null"
                    @click.prevent="addNewContactToThisCampaign"
                    >Add this contact</vs-button
                  >
                  <vs-button
                    class="ml-3"
                    @click.prevent="requestNewContactWithForm()"
                  >
                    The contact I require is not shown in this list, I want to
                    create a new contact</vs-button
                  >
                </div>
              </div>
            </div>
          </div>

          <vs-col vs-lg="1" vs-sm="1" vs-xs="12"> </vs-col>

          <vs-col
            vs-lg="5"
            vs-sm="5"
            vs-xs="12"
            v-if="selected_all_existing_database_contacts"
          >
            <u> <h4 class="font-bold text-lg mb-5">Contact Details</h4></u>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/4 w-full">
                <h5>Title:</h5>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ matchedContactDescription.title }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/4 w-full">
                <h5>Forename:</h5>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ matchedContactDescription.forename }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/4 w-full">
                <h5>Surname:</h5>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{ matchedContactDescription.surname }}
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/4 w-full">
                <h5>Job Title:</h5>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{
                  matchedContactDescription.job_title != undefined &&
                  matchedContactDescription.job_title.length > 0
                    ? matchedContactDescription.job_title[0].job_title
                    : ''
                }}
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/4 w-full">
                <h5>Seniority:</h5>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{
                  matchedContactDescription.seniority != undefined &&
                  matchedContactDescription.seniority.length > 0
                    ? matchedContactDescription.seniority[0].seniority
                    : ''
                }}
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/4 w-full">
                <h5>Role:</h5>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{
                  matchedContactDescription.role != undefined &&
                  matchedContactDescription.role.length > 0
                    ? matchedContactDescription.role[0].role
                    : ''
                }}
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/4 w-full">
                <h5>Sub Role:</h5>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                {{
                  matchedContactDescription.sub_role != undefined &&
                  matchedContactDescription.sub_role.length > 0
                    ? matchedContactDescription.sub_role[0].sub_role
                    : ''
                }}
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/6 w-full">
                <h5>Email</h5>
              </div>
            </div>

            <template
              v-for="(email, index) in matchedContactDescription.emails"
            >
              <div class="vx-row p-2">
                <div class="vx-col sm:w-1/4 w-full">
                  {{ email.email }}
                </div>
              </div>
            </template>

            <vs-divider class="m-5" />

            <div class="vx-row mb-6">
              <div class="vx-col w-full">
                <h5>Social Media Pages</h5>
              </div>
            </div>

            <template
              v-for="(
                social_media, index
              ) in matchedContactDescription.social_medias"
            >
              <div class="vx-row">
                <div class="vx-col w-full">
                  {{ social_media.social_media }}
                  {{ ' - ' + social_media.summary }}
                </div>
              </div>
            </template>

            <vs-divider class="m-5" />

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/6 w-full">
                <h5>DDI</h5>
              </div>
            </div>

            <template v-for="(ddi, index) in matchedContactDescription.ddis">
              <div class="vx-row p-2">
                <div class="vx-col w-full">
                  {{ ddi.ddi == null ? '' : ddi.ddi_phone_code + ' - '
                  }}{{ ddi.ddi }}
                </div>
              </div>
            </template>

            <vs-divider class="m-5" />

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/6 w-full">
                <h5>Mobile</h5>
              </div>
              <div class="vx-col w-full"></div>
            </div>

            <template
              v-for="(mobile, index) in matchedContactDescription.mobiles"
            >
              <div class="vx-row p-2">
                <div class="vx-col w-full">
                  {{
                    mobile.mobile == null
                      ? ''
                      : mobile.mobile_phone_code + ' - '
                  }}{{ mobile.mobile }}
                </div>
              </div>
            </template>
          </vs-col>
        </div>
      </div>
    </vs-popup>

    <vs-popup
      fullscreen
      title="Request New Contact"
      :active.sync="RequestNewContactFormPopupPopupActive"
      :button-close-hidden="true"
      @close="closeRequestNewContactFormPopup()"
    >
      <form data-vv-scope="AddNewContactForm">
        <vs-row vs-w="12" class="mb-5">
          <vs-col vs-lg="8" vs-sm="8" vs-xs="12">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Title:</span>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  class="w-full"
                  name="title"
                  v-model="contactDescription.title"
                  data-vv-as="Title"
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Forename:</span>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  class="w-full"
                  name="AddNewContactForm.forename"
                  data-vv-as="Forename"
                  v-validate="'required'"
                  v-model="contactDescription.forename"
                />
              </div>
              <span
                class="text-danger text-sm mt-2 ml-16"
                v-show="errors.has('AddNewContactForm.forename')"
                >{{ errors.first('AddNewContactForm.forename') }}</span
              >
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Surname:</span>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  class="w-full"
                  name="AddNewContactForm.surname"
                  data-vv-as="Surname"
                  v-validate="'required'"
                  v-model="contactDescription.surname"
                />
              </div>
              <span
                class="text-danger text-sm mt-2 ml-16"
                v-show="errors.has('AddNewContactForm.surname')"
                >{{ errors.first('AddNewContactForm.surname') }}</span
              >
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Job Title:</span>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  v-validate="'required'"
                  name="AddNewContactForm.job_title"
                  data-vv-as="Job Title"
                  class="w-full"
                  v-model="contactDescription.job_title"
                />
              </div>
              <span
                class="text-danger text-sm mt-2 ml-16"
                v-show="errors.has('AddNewContactForm.job_title')"
                >{{ errors.first('AddNewContactForm.job_title') }}</span
              >
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Seniority:</span>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <div
                  :class="{
                    correction_field_input_class:
                      correction_fields_array.includes('seniority')
                  }"
                >
                  <v-select
                    name="seniority"
                    data-vv-as="Seniority"
                    label="seniority"
                    :options="contacts.seniorities"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="contactDescription.seniority"
                  />
                </div>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Role:</span>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <div
                  :class="{
                    correction_field_input_class:
                      correction_fields_array.includes('role')
                  }"
                >
                  <v-select
                    data-vv-as="Role"
                    name="role"
                    label="role"
                    :options="contacts.roles"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="contactDescription.role"
                  />
                </div>
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Sub Role:</span>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <v-select
                  data-vv-as="Sub Role"
                  name="sub_role"
                  label="sub_role"
                  :options="contacts.sub_roles"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  v-model="contactDescription.sub_role"
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/2 w-full">
                <h5 class="mb-5">Email</h5>

                <div class="vx-row p-2">
                  <div class="vx-col sm:w-1/2 w-full">
                    <vs-input
                      class="w-full"
                      name="email"
                      v-model="contactDescription.email"
                      data-vv-as="Email"
                    />
                  </div>

                  <vs-button
                    color="primary"
                    @click="validateEmailZeroBounce(contactDescription.email)"
                    type="filled"
                    >Check & Add</vs-button
                  >

                  <span class="ml-5">{{ email_validate_status }} </span>
                </div>
              </div>
              <div class="vx-col sm:w-1/5 w-full"></div>
            </div>

            <template v-for="(email, index) in contactDescription.emails">
              <div class="m-5">
                {{ email.email }}

                <vs-icon
                  class="removeButton"
                  @click="removeSelectedEmail(email)"
                  color="success"
                  icon="clear"
                >
                </vs-icon>
              </div>
            </template>

            <vs-divider class="m-5" />

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/2 w-full">
                <h5 class="mb-5">Social Media</h5>

                <div class="vx-row p-2">
                  <div class="vx-col sm:w-1/2 w-full">
                    <vs-input
                      class="w-full"
                      name="social_media"
                      v-model="contactDescription.social_media"
                      data-vv-as="Social Media"
                    />
                  </div>
                  <div class="vx-col sm:w-1/2 w-full">
                    <vs-textarea v-model="contactDescription.summary" />
                  </div>
                </div>
              </div>
              <div class="vx-col sm:w-1/5 w-full">
                <vs-button
                  color="primary"
                  @click="
                    addSocialMedia(
                      contactDescription.social_media,
                      contactDescription.summary
                    )
                  "
                  type="filled"
                  >Check & Add</vs-button
                >
              </div>
            </div>

            <template
              v-for="(social_media, index) in contactDescription.social_medias"
            >
              <div class="m-5">
                {{ social_media.social_media }}
                {{ ' - ' + social_media.summary }}

                <vs-icon
                  class="removeButton"
                  @click="removeSelectedSocialMedia(social_media)"
                  color="success"
                  icon="clear"
                >
                </vs-icon>
              </div>
            </template>

            <vs-divider class="m-5" />

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/6 w-full">
                <h5 class="mb-5">DDI</h5>
              </div>
              <div class="vx-col sm:w-1/5 w-full">
                <vs-button color="primary" @click="addDDI" type="filled"
                  >Add</vs-button
                >
              </div>
            </div>

            <template v-for="(ddi, index) in contactDescription.ddis">
              <div class="vx-row p-2">
                <div class="vx-col sm:w-1/5 w-full">
                  <div
                    :class="{
                      correction_field_input_class:
                        correction_fields_array.includes('ddi_phone_code')
                    }"
                  >
                    <v-select
                      name="ddi_phone_code"
                      class="ddi_phone_code"
                      label="name_with_code"
                      :options="all_phone_codes"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      v-model="ddi.ddi_phone_code"
                    />
                  </div>

                  <span
                    class="text-danger text-sm mt-2 ml-16"
                    v-show="errors.has('ddi')"
                    >{{ errors.first('ddi') }}</span
                  >
                </div>
                <div class="vx-col sm:w-1/5 w-full">
                  <vs-input
                    class="w-full"
                    name="ddi"
                    v-model="ddi.ddi"
                    data-vv-as="DDI"
                  />
                </div>

                <div class="vx-col sm:w-1/5 w-full">
                  <!-- <vs-radio
              v-model="ddi.primary"
              :vs-value="ddi.primary"
              class="mr-4"
              vs-name="primary_ddi"
            ></vs-radio
            > -->

                  <vs-icon
                    class="removeButton"
                    @click="removeSelectedDDI(ddi)"
                    color="success"
                    icon="clear"
                  >
                  </vs-icon>
                </div>
              </div>
            </template>

            <vs-divider class="m-5" />

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/6 w-full">
                <h5 class="mb-5">Mobile</h5>
              </div>
              <div class="vx-col sm:w-1/5 w-full">
                <vs-button color="primary" @click="addMobile" type="filled"
                  >Add</vs-button
                >
              </div>
            </div>

            <template v-for="(mobile, index) in contactDescription.mobiles">
              <div class="vx-row p-2">
                <div class="vx-col sm:w-1/5 w-full">
                  <div
                    :class="{
                      correction_field_input_class:
                        correction_fields_array.includes('mobile_phone_code')
                    }"
                  >
                    <v-select
                      name="mobile_phone_code"
                      class="mobile_phone_code"
                      label="name_with_code"
                      :options="all_phone_codes"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      v-model="mobile.mobile_phone_code"
                    />
                  </div>

                  <span
                    class="text-danger text-sm mt-2 ml-16"
                    v-show="errors.has('mobile')"
                    >{{ errors.first('mobile') }}</span
                  >
                </div>
                <div class="vx-col sm:w-1/5 w-full">
                  <vs-input
                    class="w-full"
                    name="mobile"
                    v-model="mobile.mobile"
                    data-vv-as="Mobile"
                  />
                </div>

                <div class="vx-col sm:w-1/5 w-full">
                  <!-- <vs-radio
              v-model="mobile.primary"
              :vs-value="mobile.primary"
              class="mr-4"
              vs-name="primary_mobile"
            ></vs-radio
            > -->

                  <vs-icon
                    class="removeButton"
                    @click="removeSelectedMobile(mobile)"
                    color="success"
                    icon="clear"
                  >
                  </vs-icon>
                </div>
              </div>
            </template>
            <vs-divider class="m-10" />

            <div class="vx-row">
              <div class="vx-col sm:w-1/5 w-full"></div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-button class="mr-3" @click.prevent="submitContactForm"
                  >Add this Contact</vs-button
                >
              </div>
            </div>
          </vs-col>
        </vs-row>
      </form>
    </vs-popup>

    <vs-popup
      style="z-index: 99999"
      :fullscreen="showMatchedContactDetails"
      title="List of contacts Matched By Email"
      :active.sync="MatchedEmailPopupActive"
      :button-close-hidden="true"
      @close="closeMatchedEmailPopup()"
    >
      <vs-row vs-w="12" class="mb-5">
        <vs-col
          :vs-lg="showMatchedContactDetails ? 6 : 12"
          :vs-sm="showMatchedContactDetails ? 6 : 12"
          vs-xs="12"
        >
          <div class="text-center">
            <p class="font-bold text-lg">
              We have a match for this email. Do you want to request that this
              contact is moved to this account and added to the campaign?
            </p>
            <vs-divider class="m-5" />

            <template v-for="(match, index) in matched_emails">
              <p class="pl-2">Current Company : {{ match.company_name }}</p>
              <p class="p-2">
                Contact : {{ match.title }} {{ match.forename }}
                {{ match.surname }}

                <vs-icon
                  @click.stop="viewMatchedContactDetails(match)"
                  size="small"
                  icon="info"
                  style="cursor: pointer; margin-left: 15px"
                ></vs-icon>
              </p>
              <p class="p-2">{{ match.job_title }}</p>

              <vs-divider class="m-5" />
            </template>

            <vs-button @click="CancelEmailPopup()" class="mr-3 mt-2"
              >Cancel</vs-button
            >
          </div>
        </vs-col>
        <vs-col vs-lg="1" vs-sm="1" vs-xs="12"> </vs-col>

        <vs-col vs-lg="5" vs-sm="5" vs-xs="12" v-if="showMatchedContactDetails">
          <u> <h4 class="font-bold text-lg mb-5">Contact Details</h4></u>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/4 w-full">
              <h5>Title:</h5>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              {{ matchedContactDescription.title }}
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/4 w-full">
              <h5>Forename:</h5>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              {{ matchedContactDescription.forename }}
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/4 w-full">
              <h5>Surname:</h5>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              {{ matchedContactDescription.surname }}
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/4 w-full">
              <h5>Job Title:</h5>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              {{ matchedContactDescription.job_title }}
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/4 w-full">
              <h5>Seniority:</h5>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              {{
                matchedContactDescription.seniority != undefined &&
                matchedContactDescription.seniority.length > 0
                  ? matchedContactDescription.seniority[0].seniority
                  : ''
              }}
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/4 w-full">
              <h5>Role:</h5>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              {{
                matchedContactDescription.role != undefined &&
                matchedContactDescription.role.length > 0
                  ? matchedContactDescription.role[0].role
                  : ''
              }}
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/4 w-full">
              <h5>Sub Role:</h5>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              {{
                matchedContactDescription.sub_role != undefined &&
                matchedContactDescription.sub_role.length > 0
                  ? matchedContactDescription.sub_role[0].sub_role
                  : ''
              }}
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <h5>Email</h5>
            </div>
          </div>

          <template v-for="(email, index) in matchedContactDescription.emails">
            <div class="vx-row p-2">
              <div class="vx-col sm:w-1/4 w-full">
                {{ email.email }}
              </div>
            </div>
          </template>

          <vs-divider class="m-5" />

          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <h5>Social Media Pages</h5>
            </div>
          </div>

          <template
            v-for="(
              social_media, index
            ) in matchedContactDescription.social_medias"
          >
            <div class="vx-row">
              <div class="vx-col w-full">
                {{ social_media.social_media }}
                {{ ' - ' + social_media.summary }}
              </div>
            </div>
          </template>

          <vs-divider class="m-5" />

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <h5>DDI</h5>
            </div>
          </div>

          <template v-for="(ddi, index) in matchedContactDescription.ddis">
            <div class="vx-row p-2">
              <div class="vx-col w-full">
                {{ ddi.ddi == null ? '' : ddi.ddi_phone_code + ' - '
                }}{{ ddi.ddi }}
              </div>
            </div>
          </template>

          <vs-divider class="m-5" />

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <h5>Mobile</h5>
            </div>
            <div class="vx-col w-full"></div>
          </div>

          <template
            v-for="(mobile, index) in matchedContactDescription.mobiles"
          >
            <div class="vx-row p-2">
              <div class="vx-col w-full">
                {{
                  mobile.mobile == null ? '' : mobile.mobile_phone_code + ' - '
                }}{{ mobile.mobile }}
              </div>
            </div>
          </template>
          <vs-divider class="m-10" />

          <vs-button
            @click="moveMasterDBContactToNewRequestAccount()"
            class="mr-3 mb-2"
            >Yes - move and add the contact</vs-button
          >

          <vs-button @click="createDifferentContact()" class="mr-3 mb-2"
            >No - I want to create a different contact</vs-button
          >
        </vs-col>
      </vs-row>
    </vs-popup>

    <vs-popup
      style="z-index: 999999"
      :fullscreen="showMatchedContactDetails"
      title="List of contacts Matched By Social Media"
      :active.sync="MatchedSocialMediaPopupActive"
      :button-close-hidden="true"
      @close="closeMatchedSocialMediaPopup()"
    >
      <vs-row vs-w="12" class="mb-5">
        <vs-col
          :vs-lg="showMatchedContactDetails ? 6 : 12"
          :vs-sm="showMatchedContactDetails ? 6 : 12"
          vs-xs="12"
        >
          <div class="text-center">
            <p class="font-bold text-lg">
              We have a match for this social media. Do you want to request that
              this contact is moved to this account and added to the campaign?
            </p>
            <vs-divider class="m-5" />

            <template v-for="(match, index) in matched_social_medias">
              <p class="pl-2">Current Company : {{ match.company_name }}</p>
              <p class="p-2">
                Contact : {{ match.title }} {{ match.forename }}
                {{ match.surname }}

                <vs-icon
                  @click.stop="viewMatchedContactDetails(match)"
                  size="small"
                  icon="info"
                  style="cursor: pointer; margin-left: 15px"
                ></vs-icon>
              </p>
              <p class="p-2">{{ match.job_title }}</p>

              <vs-divider class="m-5" />
            </template>

            <vs-button @click="CancelSocialMediaPopup()" class="mr-3 mt-2"
              >Cancel</vs-button
            >
          </div>
        </vs-col>

        <vs-col vs-lg="1" vs-sm="1" vs-xs="12"> </vs-col>
        <vs-col vs-lg="5" vs-sm="5" vs-xs="12" v-if="showMatchedContactDetails">
          <u> <h4 class="font-bold text-lg mb-5">Contact Details</h4></u>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/4 w-full">
              <h5>Title:</h5>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              {{ matchedContactDescription.title }}
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/4 w-full">
              <h5>Forename:</h5>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              {{ matchedContactDescription.forename }}
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/4 w-full">
              <h5>Surname:</h5>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              {{ matchedContactDescription.surname }}
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/4 w-full">
              <h5>Job Title:</h5>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              {{ matchedContactDescription.job_title }}
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/4 w-full">
              <h5>Seniority:</h5>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              {{
                matchedContactDescription.seniority != undefined &&
                matchedContactDescription.seniority.length > 0
                  ? matchedContactDescription.seniority[0].seniority
                  : ''
              }}
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/4 w-full">
              <h5>Role:</h5>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              {{
                matchedContactDescription.role != undefined &&
                matchedContactDescription.role.length > 0
                  ? matchedContactDescription.role[0].role
                  : ''
              }}
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/4 w-full">
              <h5>Sub Role:</h5>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              {{
                matchedContactDescription.sub_role != undefined &&
                matchedContactDescription.sub_role.length > 0
                  ? matchedContactDescription.sub_role[0].sub_role
                  : ''
              }}
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <h5>Email</h5>
            </div>
          </div>

          <template v-for="(email, index) in matchedContactDescription.emails">
            <div class="vx-row p-2">
              <div class="vx-col sm:w-1/4 w-full">
                {{ email.email }}
              </div>
            </div>
          </template>

          <vs-divider class="m-5" />

          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <h5>Social Media Pages</h5>
            </div>
          </div>

          <template
            v-for="(
              social_media, index
            ) in matchedContactDescription.social_medias"
          >
            <div class="vx-row">
              <div class="vx-col w-full">
                {{ social_media.social_media }}
                {{ ' - ' + social_media.summary }}
              </div>
            </div>
          </template>

          <vs-divider class="m-5" />

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <h5>DDI</h5>
            </div>
          </div>

          <template v-for="(ddi, index) in matchedContactDescription.ddis">
            <div class="vx-row p-2">
              <div class="vx-col w-full">
                {{ ddi.ddi == null ? '' : ddi.ddi_phone_code + ' - '
                }}{{ ddi.ddi }}
              </div>
            </div>
          </template>

          <vs-divider class="m-5" />

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <h5>Mobile</h5>
            </div>
            <div class="vx-col w-full"></div>
          </div>

          <template
            v-for="(mobile, index) in matchedContactDescription.mobiles"
          >
            <div class="vx-row p-2">
              <div class="vx-col w-full">
                {{
                  mobile.mobile == null ? '' : mobile.mobile_phone_code + ' - '
                }}{{ mobile.mobile }}
              </div>
            </div>
          </template>
          <vs-divider class="m-10" />

          <vs-button
            @click="moveMasterDBContactToNewRequestAccount()"
            class="mr-3 mb-2"
            >Yes - move and add the contact</vs-button
          >

          <vs-button @click="createDifferentContact()" class="mr-3 mb-2"
            >No - I want to create a different contact</vs-button
          >
        </vs-col>
      </vs-row>
    </vs-popup>

  
  </div>
</template>

<script>
import moduleContactsManagement from '@/store/contacts-management/moduleContactsManagement.js'
import moduleAccountsManagement from '@/store/accounts-management/moduleAccountsManagement.js'
import _ from 'lodash'
import defineAbilitiesFor from '@/config/abilities'
import axios from '@/axios.js'
import moduleCampaignsManagement from '@/store/campaign-management/moduleCampaignManagement.js'
import AccountAutocomplete from '@/components/autocomplete/AccountsAutocomplete.vue'
import AccountDisabledAutocomplete from '@/components/autocomplete/AccountsAutocompleteDisabled.vue'
import moduleSDSubStatusManagement from '@/store/sd-sub-status-management/moduleSDSubStatusManagement.js'
import Autocomplete from '@/components/autocomplete/Autocomplete.vue'
import vSelect from 'vue-select'
import ProgressBar from 'vue-simple-progress'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { remove } from 'lodash'
export default {
  components: {
    Autocomplete,
    'v-select': vSelect,
    ProgressBar,
    flatPickr,
    AccountAutocomplete,
    AccountDisabledAutocomplete
  },
  computed: {
    total_pages () {
      console.log('totla', this.all_total)
      return Math.ceil(this.all_total / this.limit)
    }
    // cloneItems() {
    //     var clone = this.unmatch_contacts;
    //     var startFrom = (this.pagination.page*this.pagination.rowsPerPage)-this.pagination.rowsPerPage;
    //     return clone.splice(startFrom, this.pagination.rowsPerPage);
    // }
  },
  data () {
    return {
      AddContactToThisAccountOnCampaignPopupPopupActive: false,

      selected_all_existing_database_contacts: null,
      all_existing_db_contacts: [],
      showMatchedContactDetails: false,
      matchedContactDescription: {},
      RequestNewContactFormPopupPopupActive: false,
      request_account_sd_review_id: null,
      acc_id: null,
      selected_existing_master_database_contacts: null,
      scrollClass: 'scroll-container',
      scrollClass2: 'scroll-container-2',

      existing_master_database_contacts: [],
      MoveExistingContactToThisAccountKey: 0,

      MoveExistingContactToThisAccountPopUpActive: false,
      ChooseOptionPopupActive: false,
      match_account_reason_for_account_request: null,
      searchAccountForm: true,
      addAccountForm: false,
      accountExists: false,
      submit_match_accounts: [],
      matched_websites: [],
      matched_linkedins: [],
      MatchedAccountsPopupActive: false,
      MatchedWebsitePopupActive: false,
      MatchedLinkedInPopupActive: false,
      selected_status_notes: null,
      user_role_id: null,
      account_sub_statuses: [],
      selected_account_sub_status: [],

      please_choose_status: null,
      selected_status: null,

      all_sd_status: [],
      accounts: {
        web: null,
        phone: null,
        linkedin: null,
        main_counter: 0,
        vertical: null,
        phoneTypes: [],
        phoneType: [],
        phone_code: null,
        joinedPhoneAndTypes: [],
        joinedSicAndDescription: [],
        websites: [],
        linkedins: [],
        phoneWithTypes: [],
        verticals: [],
        vertical: null,
        sic_code: null,
        sic_code_description: null,
        currency_code: null,
        revenue: null,
        no_of_employees: null,
        notes: null
      },
      accountDescription: {
        web: [],
        linkedin: [],
        satellite_office: []
      },
      isChecked: true,
      existed_contact_ids: [],
      RegistrationJurisdiction: null,
      viewAccountDescription: {},
      showUpdateSAccountDetailsPopup: false,
      updateAccountDetailsPopupActive: false,
      scrollClass: 'scroll-container',
      existing_master_database_contacts: [],
      existing_campaign_contact_matches: [],
      showUpdateSContactDetailsPopup: false,
      showAddressField: false,

      updateContactDescription: {},
      updateContactsDetailsPopupActive: false,
      editContacts: {
        account_id: null,
        primary_social_media: null,
        primary_mobile: null,
        primary_ddi: null,

        edit_primary_email: null,
        company_name: null,
        social_medias: [],
        mobiles: [],
        ddis: [],

        emails: [],
        title: null,
        forename: null,
        surname: null,
        email: null,
        job_title: null,
        ddi: null,
        mobile: null,
        ddi: null,

        seniority: null,
        role: null,
        sub_role: null,
        social_media: null,
        seniorities: [],
        sub_roles: [],
        satellite_address: {},
        satellite_office_id: null
      },

      email_validate_status: null,
      contact_validation: null,
      companySearchComponentKey: 0,
      update_contact_and_add_to_campaign_heading:
        'Update contact and Add to Campaign',
      subsidiaryPopupActive: false,
      temp_table_id: null,
      submit_match_contacts: [],
      MatchedEmailPopupActive: false,
      MatchedSocialMediaPopupActive: false,
      subsidiarycontactDescription: {},
      updateSatelliteOfficecontactDescription: {},
      all_phone_codes: [],
      head_office_country_validation: null,
      potential_contact_matches: [],
      matched_emails: [],
      matched_social_medias: [],
      user_id: null,
      user_role: null,
      registered_office_country_validation: null,
      selected_parent_company: null,
      selected_registration_jurisdiction: null,
      selected_vertical: null,
      selected_sic_code: null,
      selected_registered_office_country: null,
      selected_head_office_country: null,
      satellite_office_currency_code_validation: null,
      abilities: null,
      showHeadOfficeCountryField: true,
      showEditAutocomplete: false,
      telephone_show_no: 5,
      linkedin_show_no: 5,
      website_show_no: 5,
      popupActive: false,
      websiteExists: false,
      linkedinExists: false,
      parent_name: null,
      RegistrationJurisdiction: null,
      verticalName: null,
      headOfficeIsRegisteredOffice: false,
      satelliteOfficeheadOfficeIsRegisteredOffice: false,
      subsidiaryheadOfficeIsRegisteredOffice: false,
      overwriteDataBuildRegisteredOfficeAddressToMasterDB: false,
      overwriteDataBuildHeadOfficeAddressToMasterDB: false,
      old_head_office_address_1: null,
      old_head_office_address_2: null,
      old_head_office_address_3: null,
      old_head_office_city: null,
      old_head_office_county: null,
      old_head_office_postcode: null,
      old_head_office_country: null,
      old_head_office_address_1_update_satellite_office: null,
      old_head_office_address_2_update_satellite_office: null,
      old_head_office_address_3_update_satellite_office: null,
      old_head_office_city_update_satellite_office: null,
      old_head_office_county_update_satellite_office: null,
      old_head_office_postcode_update_satellite_office: null,
      old_head_office_country_update_satellite_office: null,
      old_registered_office_address_1_update_satellite_office: null,
      old_registered_office_address_2_update_satellite_office: null,
      old_registered_office_address_3_update_satellite_office: null,
      old_registered_office_city_update_satellite_office: null,
      old_registered_office_county_update_satellite_office: null,
      old_registered_office_postcode_update_satellite_office: null,
      old_registered_office_country_update_satellite_office: null,
      old_head_office_address_1_subsidiary: null,
      old_head_office_address_2_subsidiary: null,
      old_head_office_address_3_subsidiary: null,
      old_head_office_city_subsidiary: null,
      old_head_office_county_subsidiary: null,
      old_head_office_postcode_subsidiary: null,
      old_head_office_country_subsidiary: null,
      old_registered_office_address_1_subsidiary: null,
      old_registered_office_address_2_subsidiary: null,
      old_registered_office_address_3_subsidiary: null,
      old_registered_office_city_subsidiary: null,
      old_registered_office_county_subsidiary: null,
      old_registered_office_postcode_subsidiary: null,
      old_registered_office_country_subsidiary: null,
      old_company_registration_number: null,
      IsSoleTrader: false,
      registered_office_country_validation: null,
      head_office_country_validation: null,

      configDatePicker: {
        enableTime: false,
        dateFormat: 'Y-m-d',
        allowInvalidPreload: false
      },
      configDateAndTimePicker: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i:s',
        allowInvalidPreload: false,
        enableSeconds: true
      },
      PLeasewait: '',
      uploadPercentage: 0,
      rebuild_accounts: [],
      selected: [],
      allSelected: false,
      all_currency_codes: [],
      all_verticals: [],
      all_sic_codes: [],
      all_countries: [],
      contactDescription: {
        account_id: null,
        primary_social_media: null,
        primary_mobile: null,
        primary_ddi: null,

        primary_email: null,
        company_name: null,
        social_medias: [],
        mobiles: [],
        ddis: [],

        emails: [],
        title: null,
        forename: null,
        surname: null,
        email: null,
        job_title: null,
        ddi: null,
        mobile: null,
        ddi: null,

        seniority: null,
        role: null,
        sub_role: null,
        social_media: null,
        seniorities: [],
        sub_roles: [],
        satellite_address: {},
        satellite_office_id: null
      },
      mandatory_fields: [],
      selected_fields: null,
      correction_fields_array: [],
      vertical: null,
      selected_vertical: null,
      correction_fields: null,
      selected_registration_jurisdiction: null,
      selected_sic_code: null,
      add_or_update_title: null,
      user_id: null,
      user_role: null,
      selected_head_office_country: null,
      abilities: null,
      field_array_columns: [],
      actual_contact_name: null,
      registered_office_address_1: null,
      registered_office_address_2: null,
      registered_office_address_3: null,
      registered_office_city: null,
      registered_office_county: null,
      registered_office_postcode: null,
      registered_office_country: null,
      head_office_address_1: null,
      head_office_address_2: null,
      head_office_address_3: null,
      head_office_city: null,
      head_office_county: null,
      head_office_postcode: null,
      company_category: null,
      sic_code: null,
      revenue: null,
      currency_code: null,
      registration_jurisdiction: null,
      no_of_employees: null,
      // sic_code_description: null,
      phone_type: null,
      phone_no: null,
      phone_code: null,
      website: null,
      linkedin: null,
      status: null,
      switchboard: null,
      switchboard_phone_code: null,
      site_switchboard: null,
      site_switchboard_phone_code: null,
      company_name: null,
      selected_fields: null,
      registered_office_country_validation: null,
      EnhancedHeadOfficeAutocompleteComponentKey: 0,
      EnhancedRegOfficeAutocompleteComponentKey: 0,
      EnhancedSicCodeAutocompleteComponentKey: 0,
      EnhancedVerticalAutocompleteComponentKey: 0,
      EnhancedRegistrationJurisdictionAutocompleteComponentKey: 0,
      company_registration_number: null,
      country: null,
      isNewcontact: null,
      update_id: null,
      table: null,
      popupActive: false,
      updateData: [],
      currency_code_validation: null,
      currencyCodes: [],
      abilities: null,
      showHeadOfficeCountryField: true,
      showEditAutocomplete: false,
      telephone_show_no: 5,
      linkedin_show_no: 5,
      website_show_no: 5,
      contactExists: false,
      websiteExists: false,
      linkedinExists: false,
      parent_name: null,
      RegistrationJurisdiction: null,
      verticalName: null,
      old_head_office_address_1: null,
      old_head_office_address_2: null,
      old_head_office_address_3: null,
      old_head_office_city: null,
      old_head_office_county: null,
      old_head_office_postcode: null,
      old_head_office_country: null,
      old_company_registration_number: null,
      contacts: {
        account_id: null,
        primary_social_media: null,
        primary_mobile: null,
        primary_ddi: null,

        primary_email: null,
        company_name: null,
        social_medias: [],
        mobiles: [],
        ddis: [],

        emails: [],
        title: null,
        forename: null,
        surname: null,
        email: null,
        job_title: null,
        ddi: null,
        mobile: null,
        ddi: null,

        seniority: null,
        role: null,
        sub_role: null,
        social_media: null,
        seniorities: [],
        sub_roles: [],
        satellite_address: {},
        satellite_office_id: null
      },
      addNewcontactsPopUp: false,
      campaignDescription: [],
      abilities: null,
      campaignId: null,
      componentKey: 0,
      limit: 1,
      currentx: 1,
      paginate: { limit: 1, offset: 0 },
      tableData: [],
      header: [],
      sheetName: '',
      list2: [],
      uploaded_columns: [],
      selected_fields: [
        'ml_company',
        'ml_actual_contact_name',
        [
          [
            'Head Office Address',
            'Registered Office',
            'State',
            'Town',
            'Country',
            'Postal Code',
            'Site Office'
          ]
        ]
      ],
      unmatch_contacts: [],
      accept_text: 'Accept',
      acceptButtonColor: 'primary',
      accepted_matches: [],
      combined_matches: [],
      all_total: 0
    }
  },
  mounted () {
    this.getAllPhoneCodes()
    this.getCampaignDescription()
    this.getSeniority()
    this.getRoles()
  },
  watch: {
    selected_all_existing_database_contacts (val) {
      if (val) {
        this.viewMDBContactDetails(val)

        // this.MoveExistingContactToThisAccountPopUpActive = true
      }
    },
    selected_existing_master_database_contacts (val) {
      if (val) {
        this.viewPotentialMatchContactDetails(val)

        this.MoveExistingContactToThisAccountPopUpActive = true
      }
    },
    selected_status (val) {
      if (val) {
        console.log('STATUS CHANGED', this.user_role_id)
        this.fetchSDSubStatusByStatusIDAndRoleID(val.id, this.user_role_id)
      }
    },
    headOfficeIsRegisteredOffice (val) {
      if (val) {
        this.accountDescription.head_office_address_1 =
          this.accountDescription.registered_office_address_1
        this.accountDescription.head_office_address_2 =
          this.accountDescription.registered_office_address_2
        this.accountDescription.head_office_address_3 =
          this.accountDescription.registered_office_address_3
        this.accountDescription.head_office_city =
          this.accountDescription.registered_office_city
        this.accountDescription.head_office_county =
          this.accountDescription.registered_office_county
        this.accountDescription.head_office_postcode =
          this.accountDescription.registered_office_postcode

        this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.value =
          this.$refs.accountEditRegisteredOfficeCountryRef.$refs.suggestComponent.value
        this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.input.value =
          this.$refs.accountEditRegisteredOfficeCountryRef.$refs.suggestComponent.input.value
      } else {
        if (this.old_head_office_country == null) {
          this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.input.value =
            null
          this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.value =
            null
        } else {
          this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.input.value =
            this.old_head_office_country
          this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.value =
            this.old_head_office_country
        }

        this.accountDescription.head_office_address_1 =
          this.old_head_office_address_1
        this.accountDescription.head_office_address_2 =
          this.old_head_office_address_2
        this.accountDescription.head_office_address_3 =
          this.old_head_office_address_3
        this.accountDescription.head_office_city = this.old_head_office_city
        this.accountDescription.head_office_county = this.old_head_office_county
        this.accountDescription.head_office_postcode =
          this.old_head_office_postcode

        if (
          this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent
            .value != null ||
          this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent
            .value != ''
        ) {
          this.head_office_country_validation = null
        }

        if (
          this.$refs.accountEditRegisteredOfficeCountryRef.$refs
            .suggestComponent.value != null ||
          this.$refs.accountEditRegisteredOfficeCountryRef.$refs
            .suggestComponent.value != ''
        ) {
          this.registered_office_country_validation = null
        }
      }
    },
    'accounts.websites' (val) {
      if (val) {
        var lastItem = val[val.length - 1]
        if (this.validDomain(lastItem)) {
          this.$store
            .dispatch('accountsManagement/checkWebsiteExists', lastItem)
            .then(res => {
              if (res.data.status == 'fail') {
                this.websiteExists = true
                this.$vs.dialog({
                  color: 'primary',
                  title: `Confirm`,
                  text: 'This website already exists.',
                  accept: (this.websiteExists = false)
                })
                var index = this.accounts.websites.indexOf(lastItem)
                this.accounts.websites.splice(index, 1)
              } else {
                return
              }
            })
            .catch(err => {
              if (err.response.status === 401) {
                this.$router.replace('/login')
              }
            })
        } else {
          var index = this.accounts.websites.indexOf(lastItem)
          this.accounts.websites.splice(index, 1)
          return false
        }
      }
    },
    'accounts.linkedins' (val) {
      if (val) {
        var lastItem = val[val.length - 1]
        if (this.validDomain(lastItem)) {
          this.$store
            .dispatch('accountsManagement/checkLinkedinExists', lastItem)
            .then(res => {
              if (res.data.status == 'fail') {
                this.linkedinExists = true
                this.$vs.dialog({
                  color: 'primary',
                  title: `Confirm`,
                  text: 'This linkedin already exists.',
                  accept: (this.linkedinExists = false)
                })
                var index = this.accounts.linkedins.indexOf(lastItem)
                this.accounts.linkedins.splice(index, 1)
              } else {
                return
              }
            })
            .catch(err => {
              if (err.response.status === 401) {
                this.$router.replace('/login')
              }
            })
        } else {
          var index = this.accounts.linkedins.indexOf(lastItem)
          this.accounts.linkedins.splice(index, 1)
          return false
        }
      }
    },
    'contactDescription.role' (val) {
      this.contactDescription.sub_roles = []

      if (val) {
        if (val.id !== undefined) {
          this.getSubRole(val.id)
        } else {
          this.getSubRoleByName(val)
        }
      }
    },
    currentx: function (val, oldVal) {
      this.unmatch_contacts = this.rebuild_accounts.slice(
        (val - 1) * this.limit,
        val * this.limit
      )

      console.log('currentx', val)
    }
  },
  methods: {
    addNewContactToThisCampaign(){
        let contact_data = {
        contact_id: this.matchedContactDescription.contact_id,
        campaign_id: this.$route.params.campaignId,
        sales_developer_id: this.user_id,
        request_account_sd_review_id: this.request_account_sd_review_id
      }

      this.$store
        .dispatch(
          'contactsManagement/addNewContactToThisCampaign',
          contact_data
        )
        .then(res => {
          if (res.data.status == 'success') {
            this.$vs.loading()

            this.$vs.notify({
              color: 'success',
              title: 'Request Account & Contact',
              text: 'The account and contact was requested successfully.',
              time: 2000
            })

            setTimeout(() => {
              window.location.reload()
            }, 2000)
          }
        })
        .catch(err => {
          console.log(err)
        })
      
    },
    closeMatchedLinkedInPopup(value) {
      if (!value) this.MatchedLinkedInPopupActive = true
    },
  closeMatchedWebsitePopup(value) {
      if (!value) this.MatchedWebsitePopupActive = true
    },
    requestNewContactWithForm () {
      this.AddContactToThisAccountOnCampaignPopupPopupActive = false
      this.RequestNewContactFormPopupPopupActive = true
    },
    closeAddContactToThisAccountOnCampaignPopupPopup (value) {
      if (!value) this.AddContactToThisAccountOnCampaignPopupPopupActive = true
    },
    closeMoveExistingContact () {
      this.$router.go(0)
    },
    closeMoveExistingContactToThisAccountPopUpActive (value) {
      if (!value) this.MoveExistingContactToThisAccountPopUpActive = true
    },
    closeRequestNewContactFormPopup (value) {
      if (!value) this.RequestNewContactFormPopupPopupActive = true
    },
    closeshowUpdateSAccountDetailsPopup (value) {
      if (!value) this.updateAccountDetailsPopupActive = true
    },
    closeMatchedSocialMediaPopup (value) {
      if (!value) this.MatchedSocialMediaPopupActive = true
    },
    closeMatchedEmailPopup (value) {
      if (!value) this.MatchedEmailPopupActive = true
    },
    moveMasterDBContactToNewRequestAccount () {
      let contact_data = {
        contact_id: this.matchedContactDescription.contact_id,
        campaign_id: this.$route.params.campaignId,
        sales_developer_id: this.user_id,
        request_account_sd_review_id: this.request_account_sd_review_id
      }

      this.$store
        .dispatch(
          'contactsManagement/MoveExistingContactToThisCampaignFromAnotherAccountToThisAccount',
          contact_data
        )
        .then(res => {
          if (res.data.status == 'success') {
            this.$vs.loading()

            this.$vs.notify({
              color: 'success',
              title: 'Request Account & Contact',
              text: 'The account and contact was requested successfully.',
              time: 2000
            })

            setTimeout(() => {
              window.location.reload()
            }, 2000)
          }
        })
        .catch(err => {
          console.log(err)
        })

      // console.log('MOVE CONTACT TO NEW ACCOUNT', this.matchedContactDescription)
      // return false
    },
    createDifferentContact () {
      this.contactDescription.email = null
      this.contactDescription.social_media = null
      this.MatchedEmailPopupActive = false
      this.MatchedSocialMediaPopupActive = false
    },
    closeChooseOptionPopup (value) {
      if (!value) this.ChooseOptionPopupActive = true
    },
    MoveExistingContactToThisAccount () {
      this.showUpdateSAccountDetailsPopup = false
      this.updateAccountDetailsPopupActive = false
      this.MatchedWebsitePopupActive = false
      this.MatchedLinkedInPopupActive = false
      this.ChooseOptionPopupActive = false
      this.MoveExistingContactToThisAccountPopUpActive = true
    },
    CreateNewContactForThisAccount () {
      this.showUpdateSAccountDetailsPopup = false
      this.updateAccountDetailsPopupActive = false
      this.MatchedWebsitePopupActive = false
      this.MatchedLinkedInPopupActive = false
      this.ChooseOptionPopupActive = false

      console.log('VIEW Account DESCRIPTION', this.viewAccountDescription.id)

      if (this.viewAccountDescription.id != undefined) {
        this.getAllExistingMasterDatabaseContactsMatches(
          this.viewAccountDescription.id
        )
        this.AddContactToThisAccountOnCampaignPopupPopupActive = true
      } else {
        this.RequestNewContactFormPopupPopupActive = true
      }
    },
    DontAddContactToThisAccount () {
      this.$vs.loading()

      this.$vs.notify({
        color: 'success',
        title: 'Request Account',
        text: 'Your account request has been submitted successfully',
        time: 2000
      })

      setTimeout(() => {
        window.location.reload()
      }, 2000)
      // this.$router.go(0);
    },
     showAddAccountForm () {
      this.viewAccountDescription = {}
      this.accountDescription = {}
      this.accounts = {
        web: null,
        phone: null,
        linkedin: null,
        main_counter: 0,
        vertical: null,
        phoneTypes: [],
        phoneType: [],
        phone_code: null,
        joinedPhoneAndTypes: [],
        joinedSicAndDescription: [],
        websites: [],
        linkedins: [],
        phoneWithTypes: [],
        verticals: [],
        vertical: null,
        sic_code: null,
        sic_code_description: null,
        currency_code: null,
        revenue: null,
        no_of_employees: null,
        notes: null
      }

      this.addAccountForm = true
      this.searchAccountForm = false
       this.getPhoneTypes()
    this.getAllPhoneCodes()

      
    },
    submitContactForm () {
      let self = this
      self.$validator.errors.clear()

      self.$validator.validateAll('AddNewContactForm').then(result => {
        if (result) {
          self.addRequestContactBySD()
        } else {
          self.$vs.loading.close()
        }
        self.$vs.loading.close()
      })
    },
    submitAccountForm () {
      
      this.accountDescription.registered_office_country =
        this.$refs.accountEditRegisteredOfficeCountryRef.$refs.suggestComponent.value
      this.accountDescription.registered_office_country =
        this.$refs.accountEditRegisteredOfficeCountryRef.$refs.suggestComponent.input.value

      this.accountDescription.head_office_country =
        this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.value
      this.accountDescription.head_office_country =
        this.$refs.accountEditHeadOfficeCountryRef.$refs.suggestComponent.input.value

      this.accountDescription.sales_developer_id = this.user_id
      this.accountDescription.campaign_id = this.$route.params.campaignId

      this.$validator.validateAll().then(result => {
        if (result) {
          if (
            this.accountDescription.registered_office_country == null ||
            this.accountDescription.registered_office_country == ''
          ) {
            this.registered_office_country_validation =
              'The Registered Office Country field is required'
            this.head_office_country_validation = null
            return false
          } else {
            this.registered_office_country_validation = null
          }

          if (moduleAccountsManagement.autocomplete_selected) {
            this.accountDescription.parent =
              moduleAccountsManagement.autocomplete_selected.id
          }
          if (moduleAccountsManagement.vertical_selected) {
            this.accountDescription.vertical =
              moduleAccountsManagement.vertical_selected.id
          }
          if (moduleAccountsManagement.countries_selected) {
            this.accountDescription.registration_jurisdiction =
              moduleAccountsManagement.countries_selected.id
          }
          if (moduleAccountsManagement.head_office_country_selected) {
            this.accountDescription.head_office_country =
              moduleAccountsManagement.head_office_country_selected.name
          }

          if (moduleAccountsManagement.registered_office_country_selected) {
            this.accountDescription.registered_office_country =
              moduleAccountsManagement.registered_office_country_selected.name
          }

          if (this.accounts.phoneWithTypes.length > 0) {
            this.accountDescription.phoneWithTypes =
              this.accounts.phoneWithTypes
          }

          if (this.accounts.joinedSicAndDescription.length > 0) {
            this.accountDescription.sicWithDescription =
              this.accounts.joinedSicAndDescription
          }

          if (this.accounts.websites.length > 0) {
            this.accountDescription.web = this.accounts.websites
          }

          if (this.accounts.linkedins.length > 0) {
            this.accountDescription.linkedin = this.accounts.linkedins
          }

          if (
            this.accountDescription.revenue != null &&
            this.accountDescription.currency_code == null
          ) {
            this.currency_code_validation =
              'The currency code field is required'
            return false
          }

          this.addRequestAccountBySD()
          // if form have no errors
        } else {
          // form have errors
        }
      })
    },
    removeSelectedSiteAddress (site) {
      this.accountDescription.satellite_office =
        this.accountDescription.satellite_office.filter(item => {
          return item.counter != site.counter
        })
    },
    addRequestAccountBySD () {
      this.$store
        .dispatch(
          'accountsManagement/addRequestAccountBySD',
          this.accountDescription
        )
        .then(res => {
          if (res.data.status == 'fail') {
            this.checkCompanyExists()
          } else {
            this.request_account_sd_review_id =
              res.data.request_account_sd_review_id

            this.showUpdateSAccountDetailsPopup = false
            this.updateAccountDetailsPopupActive = false
            this.MatchedWebsitePopupActive = false
            this.MatchedLinkedInPopupActive = false
            this.ChooseOptionPopupActive = true
            // this.$vs.notify({
            //   color: "success",
            //   title: "Request Account",
            //   text: res.data.message
            // });
            // this.$router.go(0);
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    checkCompanyExists () {
      let self = this

      let data = {
        company_name: this.accountDescription.company_name,
        registered_office_country:
          this.accountDescription.registered_office_country
      }

      this.$store
        .dispatch('accountsManagement/checkCompanyExistsInMasterDatabase', data)
        .then(res => {
          console.log('checkCompanyExistsInMasterDatabase', res.data)

          if (res.data.status == 'fail') {
            let master_db_account = res.data.data
            self.viewAccountDetails(master_db_account.id)

            self.showUpdateSAccountDetailsPopup = true
            self.updateAccountDetailsPopupActive = true
            self.MatchedWebsitePopupActive = false
            self.MatchedLinkedInPopupActive = false
          } else {
            return
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },

    cancelSelectedAccountDetails () {
      this.showUpdateSAccountDetailsPopup = false
      this.updateAccountDetailsPopupActive = false
      this.MatchedWebsitePopupActive = false
      this.MatchedLinkedInPopupActive = false
    },
    matchSelectedAccountToRequestQA () {
      // match selected account to request QA
      let data = {
        matched_account_id: this.viewAccountDescription.id,
        campaign_id: this.$route.params.campaignId,
        sales_developer_id: this.user_id,
        reason_for_account_request:
          this.match_account_reason_for_account_request
      }

      this.$store
        .dispatch('accountsManagement/matchSelectedAccountToRequestQA', data)
        .then(res => {
          if (res.data.status == 'success') {
            this.request_account_sd_review_id =
              res.data.request_account_sd_review_id

            this.showUpdateSAccountDetailsPopup = false
            this.updateAccountDetailsPopupActive = false
            this.MatchedWebsitePopupActive = false
            this.MatchedLinkedInPopupActive = false
            this.ChooseOptionPopupActive = true
          }else{

            this.$vs.notify({
              color: 'danger',
              title: 'Request Account',
              text: res.data.message
            })

            this.showUpdateSAccountDetailsPopup = false
            this.updateAccountDetailsPopupActive = false
            this.MatchedWebsitePopupActive = false
            this.MatchedLinkedInPopupActive = false
            this.ChooseOptionPopupActive = false
            this.match_account_reason_for_account_request = null

          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    fetchSDSubStatusByStatusIDAndRoleID (status_id, role_id) {
      let self = this
      this.$store
        .dispatch('SDSubStatusManagement/fetchSDSubStatusByStatusIDAndRoleID', {
          status_id: status_id,
          role_id: role_id
        })
        .then(res => {
          let result = JSON.parse(res.data)

          self.account_sub_statuses = []
          self.contact_sub_statuses = []

          result.forEach(function (ele) {
            if (ele.level == 'account') {
              self.account_sub_statuses.push(ele)
            }
            if (ele.level == 'contact') {
              self.contact_sub_statuses.push(ele)
            }
          })
        })
        .catch(err => {
          console.error(err)
        })
    },
    getPhoneTypes () {
      this.$store
        .dispatch('accountsManagement/getPhoneTypes')
        .then(res => {
          this.accounts.phoneTypes = res.data
          this.accounts.phoneTypes = this.accounts.phoneTypes.filter(
            item => item.name != 'Site Switchboard'
          )
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getVerticals (inputValue) {
      return this.$store
        .dispatch('accountsManagement/getVerticals', inputValue)
        .then(response => {
          let data = moduleAccountsManagement.state.verticals
          let mappedArray = []
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].vertical
            })
          }
          return mappedArray
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    showParentName (parentId) {
      this.$store
        .dispatch('accountsManagement/getParent', parentId)
        .then(res => {
          this.$refs.EditAccountParentRef.$refs.suggestComponent.input.value =
            res.data.company_name
          this.$refs.EditAccountParentRef.$refs.suggestComponent.value =
            res.data.company_name
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.parent_name = true
            return
          }
          console.error(err)
        })
    },
    viewRegistrationJurisdiction (countryId) {
      this.$store
        .dispatch('accountsManagement/getCountry', countryId)
        .then(res => {
          this.RegistrationJurisdiction = res.data.name_1
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.accountDescription.parent = true
            return
          }
          console.error(err)
        })
    },
    showRegistrationJurisdiction (countryId) {
      this.$store
        .dispatch('accountsManagement/getCountry', countryId)
        .then(res => {
          this.$refs.EditAccountRegistrationJurisdictionRef.$refs.suggestComponent.input.value =
            res.data.name_1
          this.$refs.EditAccountRegistrationJurisdictionRef.$refs.suggestComponent.value =
            res.data.name_1
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.accountDescription.parent = true
            return
          }
          console.error(err)
        })
    },
    showVertical (verticalId) {
      this.$store
        .dispatch('accountsManagement/getVertical', verticalId)
        .then(res => {
          // this.verticalName = res.data.vertical;
          this.$refs.EditAccountVerticalRef.$refs.suggestComponent.input.value =
            res.data.vertical
          this.$refs.EditAccountVerticalRef.$refs.suggestComponent.value =
            res.data.vertical
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getCountries (inputValue) {
      return this.$store
        .dispatch('accountsManagement/getCountries', inputValue)
        .then(response => {
          let data = moduleAccountsManagement.state.countries
          // console.log(data);
          let mappedArray = []
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].name_1
            })
          }
          return mappedArray
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
   
 
    validateUpdateContactDescriptionEmailZeroBounce (email) {
      let self = this

      self.$vs.loading()

      this.$store
        .dispatch('contactsManagement/validateEmailZeroBounce', email)
        .then(res => {
          self.email_validate_status = res.data
          self.$vs.loading.close()

          console.log(res)
        })
        .catch(err => {
          console.error(err)
        })
    },
    addUpdateContactDescriptionSocialMedia () {
      this.updateContactDescription.social_medias.push({
        social_media: null,
        summary: null,
        primary: false
      })
    },
    addUpdateContactDescriptionEmail () {
      this.updateContactDescription.emails.push({
        email: null,
        primary: false
      })
    },
    addUpdateContactDescriptionDDI () {
      this.updateContactDescription.ddis.push({
        ddi: null,
        ddi_phone_code: null,
        primary: false
      })
    },
    addUpdateContactDescriptionMobile () {
      this.updateContactDescription.mobiles.push({
        mobile: null,
        mobile_phone_code: null,
        primary: false
      })
    },

    removeSelectedUpdateContactDescriptionSocialMedia (social_media) {
      this.updateContactDescription.social_medias =
        this.updateContactDescription.social_medias.filter(item => {
          return item != social_media
        })
    },
    removeSelectedUpdateContactDescriptionEmail (email) {
      this.updateContactDescription.emails =
        this.updateContactDescription.emails.filter(item => {
          return item != email
        })
    },
    removeSelectedUpdateContactDescriptionMobile (mobile) {
      this.updateContactDescription.mobiles =
        this.updateContactDescription.mobiles.filter(item => {
          return item != mobile
        })
    },
    removeSelectedUpdateContactDescriptionDDI (ddi) {
      this.updateContactDescription.ddis =
        this.updateContactDescription.ddis.filter(item => {
          return item != ddi
        })
    },

    viewPotentialMatchContactDetails (contact) {
      // return false
      let self = this
      self.updateContactDescription = {}

      // self.$validator.errors.clear()
      self.update_contact_and_add_to_campaign_heading =
        'Matched Contact Details'
      let updateContactDetail = {
        contact_id: contact.contact_id,
        account_id: contact.account_id
      }
      this.$store
        .dispatch('contactsManagement/fetchContact', updateContactDetail)
        .then(res => {
          this.updateContactDescription = res.data

          //     this.$refs.updateContactCompanyRef.$refs.suggestComponent.input.value =
          //   this.updateContactDescription.company_name
          // this.$refs.updateContactCompanyRef.$refs.suggestComponent.value =
          //   this.updateContactDescription.company_name

          console.log(
            'Previous Account Contact Description',
            self.updateContactDescription
          )

          if (self.updateContactDescription.role) {
            self.updateContactDescription.role.forEach(function (ele) {
              ele.id = ele.uuid
              return ele
            })
          }

          if (self.updateContactDescription.sub_role) {
            self.updateContactDescription.sub_role.forEach(function (ele) {
              ele.id = ele.uuid
              return ele
            })
          }

          if (self.updateContactDescription.seniority) {
            self.updateContactDescription.seniority.forEach(function (ele) {
              ele.id = ele.uuid
              return ele
            })
          }

          if (self.updateContactDescription.emails) {
            self.updateContactDescription.emails.forEach(function (ele) {
              if (ele.primary == true) {
                self.updateContactDescription.primary_email = ele.email
              }
              return ele
            })
          }

          if (self.updateContactDescription.social_medias) {
            self.updateContactDescription.social_medias.forEach(function (ele) {
              if (ele.primary == true) {
                self.updateContactDescription.primary_social_media =
                  ele.social_media
              }
              return ele
            })
          }

          if (self.updateContactDescription.mobiles) {
            self.updateContactDescription.mobiles.forEach(function (ele) {
              if (ele.primary == true) {
                self.updateContactDescription.primary_mobile = ele.mobile
              }
              return ele
            })
          }

          if (self.updateContactDescription.ddis) {
            self.updateContactDescription.ddis.forEach(function (ele) {
              if (ele.primary == true) {
                self.updateContactDescription.primary_ddi = ele.ddi
              }
              return ele
            })
          }

          if (self.updateContactDescription.job_title) {
            if (Array.isArray(self.updateContactDescription.job_title)) {
              self.updateContactDescription.job_title =
                self.updateContactDescription.job_title[0]['job_title']
            }
          }

          // self.getSubRole(self.updateContactDescription.role[0].id);

          // this.$refs.SatelliteOfficecontactEditHeadOfficeCountryRef.$refs.suggestComponent.input.value =
          //   this.updateContactDescription.head_office_country
          // this.$refs.SatelliteOfficecontactEditHeadOfficeCountryRef.$refs.suggestComponent.value =
          //   this.updateContactDescription.head_office_country

          self.showUpdateSContactDetailsPopup = true

          // self.MatchedEmailPopupActive = false

          // self.MatchedSocialMediaPopupActive = false

          // self.MatchedContactsPopupActive = false

          //     self.updateContactsDetailsPopupActive = true
        })
    },
    viewMatchedContactDetails (contact) {
      // return false
      let self = this
      self.matchedContactDescription = {}

      // self.$validator.errors.clear()
      self.update_contact_and_add_to_campaign_heading =
        'Matched Contact Details'
      let updateContactDetail = {
        contact_id: contact.contact_id,
        account_id: contact.account_id
      }
      this.$store
        .dispatch('contactsManagement/fetchContact', updateContactDetail)
        .then(res => {
          this.matchedContactDescription = res.data

          if (self.matchedContactDescription.role) {
            self.matchedContactDescription.role.forEach(function (ele) {
              ele.id = ele.uuid
              return ele
            })
          }

          if (self.matchedContactDescription.sub_role) {
            self.matchedContactDescription.sub_role.forEach(function (ele) {
              ele.id = ele.uuid
              return ele
            })
          }

          if (self.matchedContactDescription.seniority) {
            self.matchedContactDescription.seniority.forEach(function (ele) {
              ele.id = ele.uuid
              return ele
            })
          }

          if (self.matchedContactDescription.emails) {
            self.matchedContactDescription.emails.forEach(function (ele) {
              if (ele.primary == true) {
                self.matchedContactDescription.primary_email = ele.email
              }
              return ele
            })
          }

          if (self.matchedContactDescription.social_medias) {
            self.matchedContactDescription.social_medias.forEach(function (
              ele
            ) {
              if (ele.primary == true) {
                self.matchedContactDescription.primary_social_media =
                  ele.social_media
              }
              return ele
            })
          }

          if (self.matchedContactDescription.mobiles) {
            self.matchedContactDescription.mobiles.forEach(function (ele) {
              if (ele.primary == true) {
                self.matchedContactDescription.primary_mobile = ele.mobile
              }
              return ele
            })
          }

          if (self.matchedContactDescription.ddis) {
            self.matchedContactDescription.ddis.forEach(function (ele) {
              if (ele.primary == true) {
                self.matchedContactDescription.primary_ddi = ele.ddi
              }
              return ele
            })
          }

          if (self.matchedContactDescription.job_title) {
            if (Array.isArray(self.matchedContactDescription.job_title)) {
              self.matchedContactDescription.job_title =
                self.matchedContactDescription.job_title[0]['job_title']
            }
          }

          self.showMatchedContactDetails = true
        })
    },
    getAllPhoneCodes () {
      let self = this
      this.$store
        .dispatch('accountsManagement/getAllPhoneCodes')
        .then(response => {
          self.all_phone_codes = response.data
          self.all_phone_codes.forEach(function (ele) {
            if (ele.phone_code) {
              ele.name_with_code = ele.phone_code + ' - ' + ele.name_1
            }
            return ele
          })

          console.log('ALL PHONE CODES', self.all_phone_codes)
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    validDomain (userInput) {
      if (userInput) {
        var res = userInput.match(
          /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
        )
        if (res == null) {
          return false
        }
      }
      return true
    },
    editSubmitForm () {
      // console.log(this.editContactDescription)
      // return false

      let self = this
      if (this.editContactDescription.edit_primary_email) {
        this.editContactDescription.primary_email =
          this.editContactDescription.edit_primary_email
      }
      // if (
      //   self.edit_accounts.length === 0 &&
      //   self.editContactDescription.company_name == null
      // ) {
      //   self.edit_contact_validation = "The Account field is required";
      //   return false;
      // } else {
      //   if (self.edit_accounts.length != 0) {
      //     self.editContactDescription.account_id = self.edit_accounts[0].id;
      //   }
      //   self.updateEditContact();
      // }

      this.$validator.validateAll('popup-edit-form').then(result => {
        // console.log(this.editContactDescription.company_name);
        if (result) {
          if (
            self.edit_accounts.length === 0 &&
            self.editContactDescription.company_name == null
          ) {
            self.edit_contact_validation = 'The Account field is required'
            return false
          } else {
            if (self.edit_accounts.length != 0) {
              self.editContactDescription.account_id = self.edit_accounts[0].id
            }
            self.updateEditContact()
          }

          // if form have no errors
        } else {
          return false
        }
      })
    },
    updateEditContact () {
      if (Array.isArray(this.editContactDescription.role)) {
        this.editContactDescription.role = this.editContactDescription.role[0]
      }

      if (Array.isArray(this.editContactDescription.sub_role)) {
        this.editContactDescription.sub_role =
          this.editContactDescription.sub_role[0]
      }

      if (Array.isArray(this.editContactDescription.seniority)) {
        this.editContactDescription.seniority =
          this.editContactDescription.seniority[0]
      }

      // if (Array.isArray(this.editContactDescription.job_title)) {
      //   this.editContactDescription.job_title = this.editContactDescription.job_title[0];
      // }

      //       console.log("sfsdfsdf" , this.editContactDescription)
      // return false

      if (Object.keys(this.editContacts.satellite_address).length != 0) {
        this.editContactDescription.satellite_office_id =
          this.editContacts.satellite_address.uuid
      } else {
        this.editContactDescription.satellite_office_id = null
      }
      this.$store
        .dispatch(
          'contactsManagement/updateContact',
          this.editContactDescription
        )
        .then(res => {
          if (res.data.status == 'success') {
            this.$refs.EditEmailExistsInDb.gridApi.refreshServerSide({
              purge: true
            })

            this.editContactShowPopup = false
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    editContact () {
      this.viewContactpopupActive = false
      let contactId = this.contactDescription.uuid
      this.editInit(contactId)
      this.editContactShowPopup = true

      // let route = this.$router.resolve("/contacts/edit/" + contactId); // This also works.
      // window.open(route.href, "_blank");

      // this.$router.replace("edit/" + this.contactDescription.id);
      // this.$router.push({ path: `edit/${contactId}` });
    },
    editContactpopup (contact) {
      let contactId = contact.contact_id
      this.editInit(contactId)
      this.editContactShowPopup = true
    },
    viewContactDetails (contactId) {
      this.viewContactDescription = {}
      this.$store
        .dispatch('contactsManagement/fetchContact', contactId)
        .then(res => {
          this.viewContactDescription = res.data
          this.viewContactpopupActive = true
        })
        .catch(err => {
          console.error(err)
        })
    },

    viewMDBContactDetails (contactId) {
      this.matchedContactDescription = {}
      this.$store
        .dispatch('contactsManagement/fetchContact', contactId)
        .then(res => {
          this.matchedContactDescription = res.data
        })
        .catch(err => {
          console.error(err)
        })
    },

    viewContactpopup (contact) {
      this.viewContactDetails(contact.contact_id)
    },
    closeThisWindow () {
      let self = this
      self.viewContactpopupActive = false
    },
    removeSelectedSocialMedia (social_media) {
      this.contactDescription.social_medias =
        this.contactDescription.social_medias.filter(item => {
          return item != social_media
        })
    },
    removeSelectedEmail (email) {
      this.contactDescription.emails = this.contactDescription.emails.filter(
        item => {
          return item != email
        }
      )
    },
    removeSelectedMobile (mobile) {
      this.contactDescription.mobiles = this.contactDescription.mobiles.filter(
        item => {
          return item != mobile
        }
      )
    },
    removeSelectedDDI (ddi) {
      this.contactDescription.ddis = this.contactDescription.ddis.filter(
        item => {
          return item != ddi
        }
      )
    },
    handleChildEvent () {
      this.accounts = moduleAccountsManagement.state.accounts.datas
      if (this.accounts){
        this.searchAccountExistsInCampaign(this.accounts[0].id)
        
      }
      


    
    },
    selectAccountToAddContactToThisAccount () {
      this.showUpdateSContactDetailsPopup = false
      let acc = moduleAccountsManagement.state.accounts.datas
      this.acc_id = acc[0].id
      this.getExistingMasterDatabaseContactsMatchesFromCampaign(this.acc_id)
    },
    searchAccountExistsInCampaign (account_id) {
      let data = {
        account_id: account_id,
        campaign_id: this.$route.params.campaignId
      }

      return this.$store
        .dispatch(
          'accountsManagement/searchAccountExistsInCampaign',
          data
        )
        .then(response => {
          if (response) {
            if (response.data == '1'){

            this.$vs.notify({
              color: 'danger',
              title: 'Request Account',
              text: 'The account you have selected is already in the campaign.  For further information please contact the campaign manager.',
              time: 4000
            })

            
              
            }else{

              this.viewAccountDetails(account_id)
                this.showUpdateSAccountDetailsPopup = true
              this.updateAccountDetailsPopupActive = true
              this.MatchedWebsitePopupActive = false
              this.MatchedLinkedInPopupActive = false

            }
          //  console.log('acccocccc' , response.data)
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    searchAccountFromTheCampaign (inputValue) {
      let search_data = {
        search_value: inputValue,
        campaign_id: this.$route.params.campaignId
      }

      return this.$store
        .dispatch(
          'accountsManagement/searchAccountFromTheCampaign',
          search_data
        )
        .then(response => {
          if (response) {
            let data = moduleAccountsManagement.state.company_or_registration_no
            if (data) {
              console.log(data)
              let mappedArray = []
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name:
                    data[property].company_name +
                    ' - ' +
                    data[property].company_registration_number
                })
              }
              return mappedArray
            }
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    searchAccount (inputValue) {
      return this.$store
        .dispatch('accountsManagement/getCompanyOrRegistrationNo', inputValue)
        .then(response => {
          if (response) {
            let data = moduleAccountsManagement.state.company_or_registration_no
            if (data) {
              console.log(data)
              let mappedArray = []
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name:
                    data[property].company_name +
                    ' - ' +
                    data[property].company_registration_number
                })
              }
              return mappedArray
            }
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getSeniority () {
      this.$store
        .dispatch('contactsManagement/getSeniority')
        .then(res => {
          this.contacts.seniorities = res.data
          // console.log(this.contacts.seniorities);
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getRoles () {
      this.$store
        .dispatch('contactsManagement/getRoles')
        .then(res => {
          this.contacts.roles = res.data
          // console.log("Roles", this.contacts.roles);
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getSubRole (role_id) {
      // alert(role_id)
      // if(!role_id){
      // this.contactDescription.sub_role = null

      // }
      this.$store
        .dispatch('contactsManagement/getSubRoles', role_id)
        .then(res => {
          this.contacts.sub_roles = res.data
        })
        .catch(err => {
          console.error(err)
        })
    },
    getSubRoleByName (role_name) {
      // alert(role_id)
      // if(!role_id){
      // this.contactDescription.sub_role = null

      // }
      this.$store
        .dispatch('contactsManagement/getSubRolesByName', role_name)
        .then(res => {
          this.contacts.sub_roles = res.data
        })
        .catch(err => {
          console.error(err)
        })
    },
    goBack: function () {
      this.$router.go(-1)
    },
    removeSelectedPhone (selected) {
      this.contacts.joinedPhoneAndTypes =
        this.contacts.joinedPhoneAndTypes.filter(item => {
          return item != selected
        })
    },
    validDomain (userInput) {
      if (userInput) {
        var res = userInput.match(
          /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
        )
        if (res == null) {
          return false
        }
      }
      return true
    },

    validateEmailZeroBounce (email) {
      let self = this
      self.showMatchedContactDetails = false

      if (email != null && email != '') {
        self.$vs.loading()

        this.$store
          .dispatch('contactsManagement/validateEmailZeroBounce', email)
          .then(res => {
            self.email_validate_status = res.data
            self.$vs.loading.close()

            self.addEmail()

            console.log(res)
          })
          .catch(err => {
            self.$vs.loading.close()

            console.error(err)
          })
      }
    },
    addDDI () {
      this.contactDescription.ddis.push({
        ddi: null,
        ddi_phone_code: null,
        primary: false
      })
    },
    addMobile () {
      this.contactDescription.mobiles.push({
        mobile: null,
        mobile_phone_code: null,
        primary: false
      })
    },
    submitExistingMasterDatabaseContacts () {
      let self = this
      let contact_data = {
        contact_id: this.selected_existing_master_database_contacts.uuid,
        campaign_id: this.$route.params.campaignId,
        sales_developer_id: this.user_id,
        request_account_sd_review_id: this.request_account_sd_review_id,
        original_account_id : this.acc_id
      }

      this.$store
        .dispatch(
          'contactsManagement/MoveExistingContactToThisCampaignFromAnotherAccountToThisAccount',
          contact_data
        )
        .then(res => {
          if (res.data.status == 'success') {
            this.$vs.loading()

            this.$vs.notify({
              color: 'success',
              title: 'Request Account & Contact',
              text: 'The request to move the contact has been submitted successfully.',
              time: 2000
            })

            setTimeout(() => {
              window.location.reload()
            }, 2000)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },

    getCampaignDescription () {
      const campaignId = this.$route.params.campaignId
      this.$store
        .dispatch('campaignsManagement/fetchCampaign', campaignId)
        .then(res => {
          this.campaignDescription = res.data
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = true
            return
          }
          console.error(err)
        })
    },

    // checkDuplicateExists() {
    //   let self = this;
    //   self.paginate.campaignId = self.campaignId;
    //   axios
    //     .post(
    //       this.$base_url + "/api/contacts/deduplicate_csv_contacts_data",
    //       self.paginate
    //     )
    //     .then(response => {
    //       let result = JSON.parse(response.data);

    //       if (result.length == 0) {

    //         self.$router
    //           .push(
    //             "/contacts/optionsAfterImportcontactToCampaign/" +
    //             self.campaignId
    //           )
    //           .catch(() => { });
    //           this.$vs.loading.close();

    //       } else {
    //         this.deduplicateOldNewCSV();
    //       }
    //     })
    //     .catch(error => {
    //       console.log(error);
    //     });
    // },

    ucFirstAllWords (str) {
      var pieces = str.split(' ')
      for (var i = 0; i < pieces.length; i++) {
        var j = pieces[i].charAt(0).toUpperCase()
        pieces[i] = j + pieces[i].substr(1)
      }
      return pieces.join(' ')
    },
    formatUploadedHeader (s) {
      if (typeof s !== 'string') return ''
      if (s.startsWith('ml_')) return ''
      // s = s.replace("_", " ");
      // s = s.replace("_", " ");
      // s = s.replace("_", " ");
      // s = s.replace("slave", " ");
      // s = s.replace("ml", " ");
      return s
    },
    // unmatchedIndividualBuildData () {
    //   let self = this
    //   this.$vs.loading()
    //   let data = {}
    //   data.campaignId = this.campaignId
    //   data.user_id = this.user_id
    //   axios
    //     .post(
    //       this.$base_url +
    //         '/api/contacts/get_accounts_that_have_no_contacts',
    //       data
    //     )
    //     .then(response => {
    //       let response_data = JSON.parse(response.data)

    //       console.log("RESPSSS" , response_data.rows)

    //       if( response_data.rows.length == 0 ){
    //         self.$vs.notify({
    //           color: 'success',
    //           title: 'No Build Contacts',
    //           text: 'There are no build contacts available.'
    //         })

    //         self.$router.push(
    //           '/data_build/contacts_data_administration_campaigns'
    //         )

    //         return false
    //       }

    //       self.unmatch_contacts = response_data.rows.slice(
    //         (self.currentx - 1) * self.limit,
    //         self.currentx * self.limit
    //       )

    //       self.rebuild_accounts = response_data.rows

    //       self.rebuild_accounts = self.rebuild_accounts.map(el => {
    //         let resultobj = {}
    //         Object.entries(el).map(([key, val]) => {
    //           resultobj[
    //             key.split(' ').join('_').replace(/\W+/g, '').toLowerCase()
    //           ] = val
    //           return resultobj
    //         })
    //         return resultobj
    //       })

    //       self.writeMasterDatabaseAndMatch(self.rebuild_accounts[0])

    //       let total = response_data.total_pages
    //       self.all_total = total

    //       // this.table = response_data.campaign_table_data[0]['table_name'];
    //       self.$vs.loading.close()
    //     })
    //     .catch(error => {
    //       console.log(error)
    //     })
    // },

    removeSelectedWeb (url) {
      this.accountDescription.web = this.accountDescription.web.filter(item => {
        return item != url
      })
    },
    removeSelectedLinkedin (url) {
      this.accountDescription.linkedin =
        this.accountDescription.linkedin.filter(item => {
          return item != url
        })
    },
    removeSelectedPhone (phone) {
      this.accountDescription.phone = this.accountDescription.phone.filter(
        item => {
          return item != phone
        }
      )
      this.accountDescription.phone = this.accountDescription.phone
    },
    removeSelectedSicCode (sic_code) {
      this.accountDescription.sic_code =
        this.accountDescription.sic_code.filter(item => {
          return item != sic_code
        })
      this.accountDescription.phone = this.accountDescription.phone
    },
    removeNewSelectedSicCode (selected) {
      this.accounts.joinedSicAndDescription =
        this.accounts.joinedSicAndDescription.filter(item => {
          return item != selected
        })
    },
    removeNewSelectedPhone (selected) {
      this.accounts.joinedPhoneAndTypes =
        this.accounts.joinedPhoneAndTypes.filter(item => {
          return item != selected
        })
    },
    validDomain (userInput) {
      if (userInput) {
        var res = userInput.match(
          /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
        )
        if (res == null) {
          return false
        }
      }
      return true
    },

    addEmail () {
      this.showMatchedContactDetails = false

      if (
        this.contactDescription.email == undefined ||
        this.contactDescription.email == null
      ) {
        this.contactDescription.email = []
      }

      this.getMatchedEmails(this.contactDescription.email)
    },
    AddEmailAnyWay () {
      this.showMatchedContactDetails = false

      if (
        !this.contactDescription.emails.includes(this.contactDescription.email)
      ) {
        this.contactDescription.emails.push({
          email: this.contactDescription.email,
          primary: false
        })
      }

      this.contactDescription.email = null
      this.MatchedEmailPopupActive = false
    },
    CancelEmailPopup () {
      this.showMatchedContactDetails = false

      this.contactDescription.email = null
      this.MatchedEmailPopupActive = false
    },
    addSocialMedia () {
      this.showMatchedContactDetails = false

      if (
        this.contactDescription.social_media == undefined ||
        this.contactDescription.social_media == null
      ) {
        this.contactDescription.social_media = []
      }

      this.getMatchedSocialMedias(
        this.contactDescription.social_media,
        this.contactDescription.summary
      )
    },
    AddSocialMediaAnyWay () {
      this.showMatchedContactDetails = false

      if (this.contactDescription.summary == undefined) {
        this.contactDescription.summary = ''
      }

      console.log(
        'ADDING ANY WAY',
        this.contactDescription.social_media,
        this.contactDescription.summary
      )

      if (
        !this.contactDescription.social_medias.includes(
          this.contactDescription.social_media
        )
      ) {
        this.contactDescription.social_medias.push({
          social_media: this.contactDescription.social_media,
          summary: this.contactDescription.summary,
          primary: false
        })
      }

      this.contactDescription.social_media = null
      this.contactDescription.summary = null
      this.MatchedSocialMediaPopupActive = false
    },
    CancelSocialMediaPopup () {
      this.showMatchedContactDetails = false

      this.contactDescription.social_media = null
      this.contactDescription.summary = null
      this.MatchedSocialMediaPopupActive = false
    },

    AddMatchedNoneCoreFields () {
      this.$store
        .dispatch(
          'contactsManagement/AddMatchedNoneCoreFields',
          this.contactDescription
        )
        .then(res => {
          if (res.data.status == 'success') {
            console.log('Matched None Core Fields Added Successfully')
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    addRequestContactBySD () {
      let self = this

      if (Array.isArray(this.contactDescription.role)) {
        this.contactDescription.role = this.contactDescription.role[0]
      }

      if (Array.isArray(this.contactDescription.sub_role)) {
        this.contactDescription.sub_role = this.contactDescription.sub_role[0]
      }

      if (Array.isArray(this.contactDescription.seniority)) {
        this.contactDescription.seniority = this.contactDescription.seniority[0]
      }

      this.contactDescription.primary_social_media = false
      this.contactDescription.primary_email = false
      this.contactDescription.primary_mobile = false
      this.contactDescription.primary_ddi = false

      this.contactDescription.request_account_sd_review_id =
        this.request_account_sd_review_id
      this.contactDescription.sales_developer_id = this.user_id
      this.contactDescription.campaignId = this.$route.params.campaignId

      this.$store
        .dispatch(
          'contactsManagement/addRequestAccountContactBySD',
          this.contactDescription
        )
        .then(res => {
          if (res.data.status == 'success') {
            this.$vs.loading()

            this.$vs.notify({
              color: 'success',
              title: 'Request Account & Contact',
              text: 'The account and contact was requested successfully.',
              time: 2000
            })

            setTimeout(() => {
              window.location.reload()
            }, 2000)

            // this.$router.go(0)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    addSicCodes () {
      // if (
      //   this.accounts.sic_code &&
      //   this.accounts.sic_code_description &&
      //   !this.accounts.joinedSicAndDescription.includes(
      //     this.accounts.sic_code + " - " + this.accounts.sic_code_description
      //   )
      // )
      //   this.accounts.joinedSicAndDescription.push(
      //     this.accounts.sic_code + " - " + this.accounts.sic_code_description
      //   );
      // let mappedSic = {};
      // mappedSic.code = this.accounts.sic_code;
      // mappedSic.description = this.accounts.sic_code_description;

      this.accounts.joinedSicAndDescription.push(
        moduleAccountsManagement.sic_codes_selected
      )

      // console.log(moduleAccountsManagement.sic_codes_selected)
      // this.accounts.sicWithDescription.push(moduleAccountsManagement.sic_codes_selected);

      this.$refs.SicCodeRefEdit.$refs.suggestComponent.selected = null
      this.$refs.SicCodeRefEdit.$refs.suggestComponent.input.value = null
      this.$refs.SicCodeRefEdit.$refs.suggestComponent.value = null

      this.selected_sic_code = null
    },
    addSiteOffice () {
      if (
        this.accountDescription.satellite_office == undefined ||
        this.accountDescription.satellite_office == null
      ) {
        this.accountDescription.satellite_office = []
      }

      // console.log('Adding Satellite Office' , this.accountDescription.satellite_office)

      this.accountDescription.satellite_office.push({
        counter: ++this.accounts.main_counter,
        address_1: null,
        address_2: null,
        address_3: null,
        city: null,
        county: null,
        postcode: null,
        country: null,
        phone: null,
        phone_code: null
      })
      // console.log(this.accounts.main_counter);
      // console.log(this.accounts.satellite);
    },
    addPhoneNumbers () {
      if (
        this.accounts.phone_code &&
        this.accounts.phone &&
        this.accounts.phoneType &&
        !this.accounts.joinedPhoneAndTypes.includes(
          this.accounts.phoneType.name +
            ' : ' +
            this.accounts.phone_code.phone_code +
            ' - ' +
            this.accounts.phone
        )
      )
        this.accounts.joinedPhoneAndTypes.push(
          this.accounts.phoneType.name +
            ' : ' +
            this.accounts.phone_code.phone_code +
            ' - ' +
            this.accounts.phone
        )
      let mappedPhoneTypes = {}
      mappedPhoneTypes.phone_no = this.accounts.phone
      mappedPhoneTypes.phone_type = this.accounts.phoneType.slug
      mappedPhoneTypes.phone_code = this.accounts.phone_code.phone_code

      this.accounts.phoneWithTypes.push(mappedPhoneTypes)
      this.accounts.phone = null
      this.accounts.phone_code = null
      this.accounts.phoneType = null
    },
    getSicCodes (inputValue) {
      return this.$store
        .dispatch('accountsManagement/getSicCodes', inputValue)
        .then(response => {
          let data = moduleAccountsManagement.state.sic_codes
          // console.log(data);
          let mappedArray = []
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].code + ' - ' + data[property].description
            })
          }
          return mappedArray
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    addWebsite () {
      this.showUpdateSAccountDetailsPopup = false
      if (
        this.accountDescription.web == undefined ||
        this.accountDescription.web == null
      ) {
        this.accountDescription.web = []
      }

      this.getMatchedWebsites(this.accounts.web)
    },
    AddWebsiteAnyWay () {
      this.showUpdateSAccountDetailsPopup = false

      if (
        this.accounts.web &&
        !this.accountDescription.web.includes(this.accounts.web)
      )
        this.accountDescription.web.push({ url: this.accounts.web })
      this.accounts.web = null
      this.MatchedWebsitePopupActive = false
    },
    CancelWebsitePopup () {
      this.viewAccountDescription = {}
      this.showUpdateSAccountDetailsPopup = false

      this.accounts.web = null
      this.MatchedWebsitePopupActive = false
    },
    addLinkedin () {
      this.showUpdateSAccountDetailsPopup = false

      if (
        this.accountDescription.linkedin == undefined ||
        this.accountDescription.linkedin == null
      ) {
        this.accountDescription.linkedin = []
      }
      this.getMatchedLinkedIn(this.accounts.linkedin)
    },
    AddLinkedInAnyWay () {
      this.showUpdateSAccountDetailsPopup = false

      if (
        this.accounts.linkedin &&
        !this.accountDescription.linkedin.includes(this.accounts.linkedin)
      )
        this.accountDescription.linkedin.push({ url: this.accounts.linkedin })
      this.accounts.linkedin = null

      this.MatchedLinkedInPopupActive = false
    },
    CancelLinkedInPopup () {
            this.viewAccountDescription = {}
      this.showUpdateSAccountDetailsPopup = false

      this.accounts.linkedin = null
      this.MatchedLinkedInPopupActive = false
    },
    getMatchedWebsites (web) {
      let self = this

      if (web != null && web != '') {
        web = web.trim()
      }

      self.matched_websites = []
      let data = {}
      data.website = web

      this.$store
        .dispatch('accountsManagement/getMatchedWebsites', data)
        .then(res => {
          if (res.data.length != 0) {
            self.matched_websites = res.data
            self.MatchedWebsitePopupActive = true
          } else {
            self.AddWebsiteAnyWay()
          }

          console.log('MATCHED WEBSITES', self.matched_websites)
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getMatchedLinkedIn (linkedin) {
      let self = this
      self.matched_linkedins = []
      let data = {}

      if (linkedin != null && linkedin != '') {
        linkedin = linkedin.trim()
      }

      data.linkedin = linkedin

      this.$store
        .dispatch('accountsManagement/getMatchedLinkedIn', data)
        .then(res => {
          if (res.data.length != 0) {
            self.matched_linkedins = res.data
            self.MatchedLinkedInPopupActive = true
          } else {
            self.AddLinkedInAnyWay()
          }
          console.log('MATCHED LINKEDIN', self.matched_linkedins)
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getParentCompany (inputValue) {
      return this.$store
        .dispatch('accountsManagement/searchAutocomplete', inputValue)
        .then(response => {
          let data = JSON.parse(JSON.parse(JSON.stringify(response.data)))
          let mappedArray = []
          for (const property in data) {
            mappedArray.push({
              id: data[property].uuid,
              name: data[property].company_name
            })
          }
          return mappedArray
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },

    viewAccountDetails (accountId) {
      this.$store
        .dispatch('accountsManagement/fetchAccount', accountId)
        .then(res => {
          this.viewAccountDescription = res.data

          if (this.viewAccountDescription.parent) {
            this.showParentName(this.viewAccountDescription.parent)
          }
          if (this.viewAccountDescription.registration_jurisdiction) {
            this.viewRegistrationJurisdiction(
              this.viewAccountDescription.registration_jurisdiction
            )
          }
          if (this.viewAccountDescription.vertical) {
            this.showVertical(this.viewAccountDescription.vertical)
          }

          this.showUpdateSAccountDetailsPopup = true
          //   this.updateAccountDetailsPopupActive = true
          //  this.MatchedWebsitePopupActive = false
          // this.MatchedLinkedInPopupActive = false
        })
        .catch(err => {
          console.error(err)
        })
    },
    getPotentialMatchesForDataBuild () {
      let self = this
      self.potential_contact_matches = []
      let data = {}
      data.company_name = this.contactDescription.company_name
      data.forename = this.contactDescription.forename
      data.surname = this.contactDescription.surname
      data.job_title = this.contactDescription.job_title
      data.email = this.contactDescription.email
      data.social_media = this.contactDescription.contact_social_media

      console.log('getPotentialMatchesForDataBuild', data)

      this.$store
        .dispatch('contactsManagement/getPotentialMatchesForDataBuild', data)
        .then(res => {
          self.potential_contact_matches = res.data

          console.log(
            'POTENTIAL CONsssACT MATCHES',
            self.potential_contact_matches
          )
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getExistingCampaignContactMatches () {
      let self = this
      self.existing_campaign_contact_matches = []
      let data = {}
      data.campaign_id = this.campaignId
      data.account_id = this.contactDescription.account_id

      console.log('ACCC', this.contactDescription)

      this.$store
        .dispatch('contactsManagement/getExistingCampaignContactMatches', data)
        .then(res => {
          self.existing_campaign_contact_matches = res.data

          self.existing_campaign_contact_matches.forEach(contact => {
            self.existed_contact_ids.push(contact.contact_id)
          })
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getExistingMasterDatabaseContactsMatchesFromCampaign (account_id) {
      let self = this
      self.existing_master_database_contacts = []
      let data = {}
      data.campaign_id = this.campaignId
      data.account_id = account_id

      this.$store
        .dispatch(
          'contactsManagement/getExistingMasterDatabaseContactsMatchesFromCampaign',
          data
        )
        .then(res => {
          self.existing_master_database_contacts = res.data
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getAllExistingMasterDatabaseContactsMatches (account_id) {
      let self = this
      self.all_existing_db_contacts = []
      let data = {}
      data.campaign_id = this.campaignId
      data.account_id = account_id

      this.$store
        .dispatch(
          'contactsManagement/getAllExistingMasterDatabaseContactsMatches',
          data
        )
        .then(res => {
          self.all_existing_db_contacts = res.data
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getMatchedEmails (email) {
      let self = this

      if (email != null && email != '') {
        email = email.trim()
      }

      self.matched_emails = []
      let data = {}
      data.email = email

      this.$store
        .dispatch('contactsManagement/getMatchedEmails', data)
        .then(res => {
          if (res.data.length != 0) {
            self.matched_emails = res.data
            self.matchedContactDescription = {}
            self.MatchedEmailPopupActive = true
          } else {
            self.AddEmailAnyWay(data.email)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    getMatchedSocialMedias (social_media, summary) {
      let self = this

      if (social_media != null && social_media != '') {
        social_media = social_media.trim()
      }

      self.matched_social_medias = []
      let data = {}
      data.social_media = social_media

      this.$store
        .dispatch('contactsManagement/getMatchedSocialMedias', data)
        .then(res => {
          if (res.data.length != 0) {
            self.matched_social_medias = res.data

            console.log('MATCHED SOCIAL MEDIAS', self.matched_social_medias)

            self.MatchedSocialMediaPopupActive = true
          } else {
            self.AddSocialMediaAnyWay(data.social_media, summary)
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getCurrencyCodes (inputValue) {
      return this.$store
        .dispatch('accountsManagement/getCurrencyCodes')
        .then(response => {
          let response_data = response.data
          let mappedArray = []
          for (const property in response_data) {
            mappedArray.push({
              id: response_data[property].id,
              label:
                response_data[property].symbol +
                ' ' +
                response_data[property].name +
                ' ' +
                response_data[property].code
            })
          }
          this.currencyCodes = mappedArray
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },

    getCorrectionFields () {
      let self = this
      self.correction_fields_array = []
      let data = {}
      data.seniority = this.contactDescription.seniority
      data.role = this.contactDescription.role
      data.sub_role = this.contactDescription.sub_role
      data.ddi_phone_code = this.contactDescription.ddi_phone_code
      data.ddi = this.contactDescription.ddi
      data.mobile_phone_code = this.contactDescription.mobile_phone_code
      data.mobile = this.contactDescription.mobile
      data.campaign_id = this.campaignId
      data.table_id = this.temp_table_id

      this.$store
        .dispatch('contactsManagement/getCorrectionFields', data)
        .then(res => {
          self.correction_fields_array = res.data

          console.log('CORRECTION FIELDS', self.correction_fields_array)
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },

    accept () {
      this.popupActive = false
    },
    reject () {
      // this.popupActive = false;
      // this.$router.push({ path: "/dashboard" });
      this.$router.go(0)
    }
  },
  created () {
    var self = this
    defineAbilitiesFor().then(function (data) {
      self.abilities = data
    })
    let userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.user_id = userInfo['uid']

    this.user_role_id = userInfo['roleId']

    if (!moduleCampaignsManagement.isRegistered) {
      this.$store.registerModule(
        'campaignsManagement',
        moduleCampaignsManagement
      )
      moduleCampaignsManagement.isRegistered = true
    }

    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule('accountsManagement', moduleAccountsManagement)
      moduleAccountsManagement.isRegistered = true
    }

    if (!moduleContactsManagement.isRegistered) {
      this.$store.registerModule('contactsManagement', moduleContactsManagement)
      moduleContactsManagement.isRegistered = true
    }

    if (!moduleSDSubStatusManagement.isRegistered) {
      this.$store.registerModule(
        'SDSubStatusManagement',
        moduleSDSubStatusManagement
      )
      moduleSDSubStatusManagement.isRegistered = true
    }

    this.campaignId = this.$route.params.campaignId

    this.getPhoneTypes()
    this.getCurrencyCodes()
  }
}
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.searchbox2 {
  padding-left: 40px;
  width: 500px;
  float: right;
  margin-top: 10px;
  margin-bottom: 50px;
}

.satellite_office_field {
  margin-right: 453px;
}

.relative {
  /* position: fixed !important; */
  z-index: 999;
  /* width: 98.5%; */
}

.vxtable {
  /* position: absolute !important; */
  margin-top: 20px;
}

.correction_field_class {
  color: red;
}

.correction_field_input_class {
  border: 1px solid red;
}

.vs-input-class {
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.2);
  font-size: 1rem;
  height: 38px;
  padding-left: 10px;
  padding-right: -10px;
  border-radius: 4px;
  background: transparent;
  transition: all 0.2s ease;
}

.scroll-container {
  max-height: 400px; /* Set a maximum height to enable scrolling */
  overflow-y: auto; /* Adds a vertical scrollbar if content exceeds max-height */
  /* Hide horizontal scrollbar if necessary */
  overflow-x: hidden;
  border: 1px solid #ccc;
  padding: 10px;
}

.scroll-container-2 {
  max-height: 800px; /* Set a maximum height to enable scrolling */
  overflow-y: auto; /* Adds a vertical scrollbar if content exceeds max-height */
  /* Hide horizontal scrollbar if necessary */
  overflow-x: hidden;
  border: 1px solid #ccc;
  padding: 10px;
}

.build-complete {
  background-color: rgb(107, 42, 42) !important;
  padding: 0.75rem 2rem;
  border: 1px solid rgb(94, 70, 70);
  color: #fff !important;
  border-radius: 4px;
  cursor: pointer;

  font-size: 18px;
}
</style>
